import { useEffect, useState, useRef } from "react";
import { Box, GlobalStyles } from "@mui/material";
import axios from "axios";
import "../../.csscode/PopUpModal.css";
import { toast } from "sonner";
import { Tab, Tabs } from "react-bootstrap";
import Select from "react-select";
import { notificationUrl } from "../Constant";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import Sidebar from "../Sidebar";
import ReactToPrint from "react-to-print";
import PrintComponent from "../worklist/PrintComponent";
import WorkItemTimeLine from "./WorkItemTimeLine";
import PopupInputField from "../PopupInputField";
import EmployeeSelectionModal from "../worklist/EmployeeSelectionModal";
import { fetchorgImageGeneral } from "../annexture/orgfetchUtils";
import CustomLoader from "../static/CustomLoader";
import { MasterDialog } from "../static/Masterpage";

const WorkItemOpen = ({
  onHide,
  selectedId,
  selectedStep,
  selectedWorklistId,
  selectedWorklistPUser,
  setRefresh,
  mode,
  fetchWorkItemData,
}) => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };
  const [activeTab, setActiveTab] = useState("open");
  const [visibleTabs, setVisibleTabs] = useState(["open"]);
  const [divisionData, setDivisionData] = useState([{}]);
  const [loading, setLoading] = useState(false);
  const [statusOptions, setStatusOptions] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [availableDivision, setavilableDivision] = useState(false);
  const [workDocs, setWorkDocs] = useState([]);
  const [formData, setFormData] = useState({});
  const [electricalFormData, setElectricalFormData] = useState({});
  const [closeFormData, setCloseFormData] = useState({});
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [radiographyFormData, setRadiographyFormData] = useState({
    radioactiveSubstance: "sealed",
  });
  const [heavyLiftFormData, setHeavyLiftFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [workId, setWorkid] = useState("");
  const [orgImg, setOrgImg] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [workProcessdto, setWorkProcessDto] = useState(null);
  const [rejectFormData, setRejectFormData] = useState({});
  const [publishFormData, setPublishFormData] = useState({});
  const [hodrejectFormData, setHodRejectionFormdata] = useState({});
  const [hodVarificationReasonFormData, setHodVarificationFormData] = useState(
    {},
  );
  const [elerejectFormData, setEleRejectFormData] = useState({});
  const [radiorejectFormData, setradioRejectFormdata] = useState({});
  const [safteyrejectFormData, setsafteyrejectFormData] = useState({});
  const [userName, setUsername] = useState("");
  const [empCode, setEmpCode] = useState("");
  const [workitem, setWorkitem] = useState(null);
  const [filePaths, setFilePaths] = useState([]);
  const [workListHistData, setWorkListHistData] = useState([]);
  const [workList, setWorkList] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [nextUser, setNextUser] = useState(false);
  const [addShow, setAddShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedEmployees, setSelectedEmployees] = useState({});
  const [employees, setEmployees] = useState([]);
  const [assignedUserOptions, setAssignedUserOptions] = useState([]);
  const addHandleClose = () => setAddShow(false);
  const addHandleShow = () => setAddShow(true);

  const formRefs = {
    open: useRef(),
    electrical: useRef(),
    saftey: useRef(),
    maintance: useRef(),
    reject: useRef(),
    publish: useRef(),
    hodVarification: useRef(),
    close: useRef(),
  };

  const printTriggerRef = useRef();

  useEffect(() => {
    fetchUserData();
    fetchDivisions();
  }, []);

  const fetchUserData = async () => {
    try {
      const savedUser = localStorage.getItem("user");

      if (savedUser) {
        const parsedUser = JSON.parse(savedUser);
        setUsername(parsedUser.userid);
        setEmpCode(parsedUser.empcode);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const fetchDivisions = async () => {
    setLoading(true);
    try {
      const response = await axios.get(apiUrl + "division", {
        headers,
      });
      const divOptions = response.data.map((op) => ({
        value: op.code,
        label: op.name,
      }));
      setDivisionData(divOptions);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDepartmentChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      fetchEmployees(value);
      setShowModal(true);
    }
    setSelectedDepartments((prev) => ({
      ...prev,
      [value]: checked,
    }));
  };

  const handleEmployeeSelection = (event) => {
    const { value, checked } = event.target;
    setSelectedEmployees((prev) => ({
      ...prev,
      [value]: checked,
    }));
  };

  const fetchEmployees = async (departmentCode) => {
    try {
      const response = await axios.get(
        `${apiUrl}employee/department/${departmentCode}`,
        { headers },
      );
      const empOptions = response.data.map((op) => ({
        value: op.code,
        label: op.name,
      }));
      setEmployees(empOptions);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const handleFilesUpdate = (newPaths) => {
    setFilePaths((prevPaths) => [...prevPaths, ...newPaths]);
  };

  const handleDeleteTemporyFiles = (updatedPaths) => {
    setFilePaths(updatedPaths);
  };

  const handleDeletePermentFiles = (updatedDocs) => {
    setWorkDocs(updatedDocs);
  };

  const handleElectricalFormChange = (e) => {
    const { name, type, checked, value } = e.target;

    setElectricalFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleRadiographFormChange = (e) => {
    const { name, type, checked, value } = e.target;
    setRadiographyFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleRadioTimeChange = (value) => {
    setRadiographyFormData((prev) => ({
      ...prev,
      permitAuthorisertime: value,
    }));
  };

  const handleRadioPermitHolderTimeChange = (value) => {
    setRadiographyFormData((prev) => ({
      ...prev,
      permitHoldertime: value,
    }));
  };

  const handleHeavyLiftFormChange = (e) => {
    const { name, value } = e.target;
    setHeavyLiftFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSafteyTimeChange = (value) => {
    setHeavyLiftFormData((prev) => ({
      ...prev,
      time: value,
    }));
  };

  const handleEleRejectReasonChange = (e) => {
    setEleRejectFormData({
      ...elerejectFormData,
      elerejectReason: e.target.value,
    });
  };

  const handleCloseReasonChange = (e) => {
    setCloseFormData({
      ...closeFormData,
      closeReason: e.target.value,
    });
  };

  const handleHodRejectReasonChange = (e) => {
    setHodRejectionFormdata({
      ...hodrejectFormData,
      hodrejectReason: e.target.value,
    });
  };

  const handleRadioRejectReasonChange = (e) => {
    setradioRejectFormdata({
      ...radiorejectFormData,
      radiorejectReason: e.target.value,
    });
  };

  const handleSafteyRejectReasonChange = (e) => {
    setsafteyrejectFormData({
      ...safteyrejectFormData,
      safteyrejectReason: e.target.value,
    });
  };

  const handleRejectReasonChange = (e) => {
    setRejectFormData({
      ...rejectFormData,
      rejectReason: e.target.value,
    });
  };

  const handlepublishReasonChange = (e) => {
    setPublishFormData({
      ...publishFormData,
      publishReason: e.target.value,
    });
  };

  const handleEletricTimeChange = (value) => {
    setElectricalFormData((prev) => ({
      ...prev,
      time: value,
    }));
  };

  const handleEletricApplicantTimeChange = (value) => {
    setElectricalFormData((prev) => ({
      ...prev,
      applicanttime: value,
    }));
  };

  const handleEletricAuthTimeChange = (value) => {
    setElectricalFormData((prev) => ({
      ...prev,
      authoriserTime: value,
    }));
  };

  const handleEletricHolderTimeChange = (value) => {
    setElectricalFormData((prev) => ({
      ...prev,
      holderTime: value,
    }));
  };

  const handleEletricExtendTimeChange = (value) => {
    setElectricalFormData((prev) => ({
      ...prev,
      extextendtime: value,
    }));
  };

  const handleEletricExtend1TimeChange = (value) => {
    setElectricalFormData((prev) => ({
      ...prev,
      extextendtime1: value,
    }));
  };

  const handleEletricExtend2TimeChange = (value) => {
    setElectricalFormData((prev) => ({
      ...prev,
      extextendtime2: value,
    }));
  };

  const handleEletricJobAuthTimeChange = (value) => {
    setElectricalFormData((prev) => ({
      ...prev,
      jobAuthrosiertime: value,
    }));
  };

  const handleEletricJobApplicantTimeChange = (value) => {
    setElectricalFormData((prev) => ({
      ...prev,
      jobApplicanttime: value,
    }));
  };

  const handleEletricJobHolderTimeChange = (value) => {
    setElectricalFormData((prev) => ({
      ...prev,
      jobholdertime: value,
    }));
  };

  const handlehodVarificationReasonChange = (e) => {
    setHodVarificationFormData({
      ...hodVarificationReasonFormData,
      hodVarificationReason: e.target.value,
    });
  };

  useEffect(() => {
    fetchData();
    fetchUserOptions();
  }, []);

  const fetchUserOptions = async () => {
    try {
      const response = await axios.get(`${apiUrl}user`, { headers });
      setAssignedUserOptions(
        response.data.map((user) => ({
          value: user.empcode,
          label: user.userid,
        })),
      );
    } catch (error) {
      toast.error("Failed to fetch users.");
    }
  };

  const fetchData = async () => {
    try {
      const savedOrg = localStorage.getItem("org");
      if (savedOrg) {
        const parsedOrg = JSON.parse(savedOrg);
        const fileUrl = await fetchorgImageGeneral(
          parsedOrg.logo,
          parsedOrg.code,
        );
        setOrgImg(fileUrl);
      }
    } catch (error) {
      console.error("Error fetching organization data:", error);
    }
  };

  const handleStatusChange = async (selected) => {
    setSelectedOption(selected);
    try {
      setLoading(true);
      const apiEndpoint = `${apiUrl}workprocessdet/nextscreenbystatus/${selectedStep}/${selected.label}`;
      const response = await axios.get(apiEndpoint, { headers });
      if (response.data.cd === 1) {
        toast.error(response.data.description);
      } else {
        if (
          selected.label === "Approve" ||
          selected.label === "Request HOD Approval"
        ) {
          const userConfirmed = window.confirm(
            "Please download this approval form and upload to documents..",
          );

          if (userConfirmed) {
            printTriggerRef.current?.handlePrint(); // Trigger the print operation
          }
        }
        setWorkProcessDto(response.data);
        if (response.data.nextuser == "D") {
          setNextUser(true);
          setavilableDivision(false);
        } else {
          setNextUser(false);
        }
        let newTab = "open";
        newTab = response.data.nextscreen;
        setVisibleTabs((prevTabs) => Array.from(new Set(["open", newTab])));
        setActiveTab(newTab);
      }
    } catch (error) {
      // toast.error("Failed to fetch data for selected status.");
    } finally {
      setLoading(false);
    }
  };

  const formatTime = (time) => {
    if (!time) return ""; // Return empty string if no time is provided

    const [timePart, period] = time.split(" "); // Split time and AM/PM part
    const [hour, minute] = timePart.split(":"); // Split hour and minute

    let hourIn24 = parseInt(hour, 10);

    // Convert to 24-hour format
    if (period === "PM" && hourIn24 !== 12) {
      hourIn24 += 12; // Convert PM to 24-hour format
    } else if (period === "AM" && hourIn24 === 12) {
      hourIn24 = 0; // 12 AM is 00 in 24-hour format
    }

    return `${hourIn24.toString().padStart(2, "0")}:${minute}`;
  };

  const isValidISODate = (dateStr) => {
    // Simple ISO format check (YYYY-MM-DD)
    return /^\d{4}-\d{2}-\d{2}$/.test(dateStr);
  };

  const convertToISO = (dateStr) => {
    // Convert 'DD-MM-YYYY' → 'YYYY-MM-DD'
    const [day, month, year] = dateStr.split("-");
    if (day && month && year) {
      return `${year}-${month}-${day}`;
    }
    return "";
  };

  useEffect(() => {
    if (selectedId !== "") {
      setLoading(true);
      const apiEndpoint = `${apiUrl}worklist/workitemlist/workItem/${selectedId}/${selectedWorklistId}`;
      axios
        .get(apiEndpoint, { headers })
        .then((response) => {
          if (response.data.cd === 1) {
            toast.error(response.data.description);
          } else {
            const workItem = response.data.workItem;

            if (workItem.division != null) {
              const divisionString = workItem.division; // Example: "101,102,103"

              if (divisionString) {
                const divisionArray = divisionString.split(","); // Convert to array

                // Convert array into object format { "101": true, "102": true, "103": true }
                const divisionObject = divisionArray.reduce((acc, division) => {
                  acc[division] = true;
                  return acc;
                }, {});
                setNextUser(false);
                setSelectedDepartments(divisionObject);
                setavilableDivision(true);
              } else {
                setavilableDivision(false);
              }
            }

            if (workItem.assignedusers != null) {
              const assignedusersString = workItem.assignedusers;

              if (assignedusersString) {
                const assignedusersArray = assignedusersString.split(",");

                const assignedusersObject = assignedusersArray.reduce(
                  (acc, assignedusers) => {
                    acc[assignedusers] = true;
                    return acc;
                  },
                  {},
                );

                setSelectedEmployees(assignedusersObject);
              }
            }

            const workDocs = response.data.workDoc;
            const workList = response.data.workList;
            const workListhistory = response.data.workListHistList;

            if (workList) {
              setWorkList(workList);
            }
            if (workListhistory) {
              setWorkListHistData(workListhistory);
            }

            if (workItem && workItem.comment) {
              setWorkid(workItem.workid);
              setWorkitem(workItem);
              const commentData = JSON.parse(workItem.comment);

              setWorkDocs(workDocs);

              if (commentData[0]) {
                const initialWorkType =
                  commentData[0].workType === "hotWork"
                    ? "hotWork"
                    : "coldWork";
                const rawDateFrom = commentData[0].dateFrom || "";
                const rawDateTo = commentData[0].dateTo || "";
                const formattedDateFrom = isValidISODate(rawDateFrom)
                  ? rawDateFrom
                  : convertToISO(rawDateFrom);

                const formattedDateTo = isValidISODate(rawDateTo)
                  ? rawDateTo
                  : convertToISO(rawDateTo);
                setFormData({
                  workType: initialWorkType,
                  permitNo: workItem.workid || "",
                  plant: commentData[0].plant || "",
                  dateFrom: formattedDateFrom,
                  dateTo: formattedDateTo,
                  timeFrom: formatTime(commentData[0].timeFrom),
                  timeTo: formatTime(commentData[0].timeTo),
                  location: commentData[0].location || "",
                  workDescription: commentData[0].workDescription || "",
                  applicantSign: commentData[0].applicantSign || "",
                  applicantName: commentData[0].applicantName || "",
                  safety1: commentData[0].safety1 || "",
                  hazard1: commentData[0].hazard1 || "",
                  safety2: commentData[0].safety2 || "",
                  hazard2: commentData[0].hazard2 || "",
                  safety3: commentData[0].safety3 || "",
                  hazard3: commentData[0].hazard3 || "",
                  safety4: commentData[0].safety4 || "",
                  hazard4: commentData[0].hazard4 || "",
                  safety5: commentData[0].safety5 || "",
                  hazard5: commentData[0].hazard5 || "",
                  safety6: commentData[0].safety6 || "",
                  safety7: commentData[0].safety7 || "",
                  hazard6: commentData[0].hazard6 || "",
                  hazard7: commentData[0].hazard7 || "",
                  ppe1: commentData[0].ppe1 || "",
                  firePrecaution1: commentData[0].firePrecaution1 || "",
                  certificate1: commentData[0].certificate1 || "",

                  ppe2: commentData[0].ppe2 || "",
                  firePrecaution2: commentData[0].firePrecaution2 || "",
                  certificate2: commentData[0].certificate2 || "",

                  ppe3: commentData[0].ppe3 || "",
                  firePrecaution3: commentData[0].firePrecaution3 || "",
                  certificate3: commentData[0].certificate3 || "",

                  ppe4: commentData[0].ppe4 || "",
                  firePrecaution4: commentData[0].firePrecaution4 || "",
                  certificate4: commentData[0].certificate4 || "",

                  ppe5: commentData[0].ppe5 || "",
                  firePrecaution5: commentData[0].firePrecaution5 || "",
                  certificate5: commentData[0].certificate5 || "",

                  ppe6: commentData[0].ppe6 || "",
                  firePrecaution6: commentData[0].firePrecaution6 || "",
                  certificate6: commentData[0].certificate6 || "",

                  ppe7: commentData[0].ppe7 || "",
                  firePrecaution7: commentData[0].firePrecaution7 || "",
                  certificate7: commentData[0].certificate7 || "",

                  ppe8: commentData[0].ppe8 || "",
                  firePrecaution8: commentData[0].firePrecaution8 || "",
                  certificate8: commentData[0].certificate8 || "",

                  permitappsign: commentData[0].permitappsign || "",
                  permitappname: commentData[0].permitappname || "",
                  permitholdsign: commentData[0].permitholdsign || "",

                  permitholdname: commentData[0].permitholdname || "",
                  permitauthdatefrom: commentData[0].permitauthdatefrom || "",
                  permitauthdateto: commentData[0].permitauthdateto || "",

                  permitauthtimefrom: commentData[0].permitauthtimefrom || "",
                  permitauthtimeto: commentData[0].permitauthtimeto || "",
                  permitauthsign: commentData[0].permitauthsign || "",

                  permitauthname: commentData[0].permitauthname || "",
                  permitwcholdersign: commentData[0].permitwcholdersign || "",
                  permitwcholdername: commentData[0].permitwcholdername || "",

                  permitwcholderdate: commentData[0].permitwcholderdate || "",
                  permitwcholdertime: commentData[0].permitwcholdertime || "",
                  permitwcapplicantsign:
                    commentData[0].permitwcapplicantsign || "",

                  permitwcapplicantname:
                    commentData[0].permitwcapplicantname || "",
                  permitwcapplicantdate:
                    commentData[0].permitwcapplicantdate || "",
                  permitwcapplicanttime:
                    commentData[0].permitwcapplicanttime || "",

                  permitwcAuthorisersign:
                    commentData[0].permitwcAuthorisersign || "",
                  permitwcAuthorisername:
                    commentData[0].permitwcAuthorisername || "",
                  permitwcAuthoriserdate:
                    commentData[0].permitwcAuthoriserdate || "",

                  permitwcAuthorisertime:
                    commentData[0].permitwcAuthorisertime || "",
                  permitwncholdersign: commentData[0].permitwncholdersign || "",
                  permitwncholdername: commentData[0].permitwncholdername || "",

                  permitwncholderdate: commentData[0].permitwncholderdate || "",
                  permitwncholdertime: commentData[0].permitwncholdertime || "",
                  permitwncapplicantsign:
                    commentData[0].permitwncapplicantsign || "",

                  permitwncapplicantname:
                    commentData[0].permitwncapplicantname || "",
                  permitwncapplicantdate:
                    commentData[0].permitwncapplicantdate || "",
                  permitwncapplicanttime:
                    commentData[0].permitwncapplicanttime || "",

                  permitwncAuthorisersign:
                    commentData[0].permitwncAuthorisersign || "",
                  permitwncAuthorisername:
                    commentData[0].permitwncAuthorisername || "",
                  permitwncAuthoriserdate:
                    commentData[0].permitwncAuthoriserdate || "",
                  permitwncAuthorisertime:
                    commentData[0].permitwncAuthorisertime || "",
                  priviousWorkComments:
                    (commentData[0]?.priviousWorkComments
                      ? commentData[0]?.priviousWorkComments + "\n"
                      : "") + (commentData[0]?.workComments || ""),
                });
              }

              if (commentData[8]) {
                setsafteyrejectFormData({
                  safteyrejectFormData:
                    commentData[8].safteyrejectFormData || "",
                });
              }
              if (commentData[4]) {
                setRejectFormData({
                  rejectReason: commentData[4].rejectReason || "",
                });
              }
              if (commentData[5]) {
                setPublishFormData({
                  publishReason: commentData[5].publishReason || "",
                });
              }
              if (commentData[7]) {
                setEleRejectFormData({
                  elerejectReason: commentData[7].elerejectReason || "",
                });
              }
              if (commentData[6]) {
                setHodVarificationFormData({
                  hodVarificationReason:
                    commentData[6].hodVarificationReason || "",
                });
              }

              if (commentData[9]) {
                setradioRejectFormdata({
                  radiorejectReason: commentData[9].radiorejectReason || "",
                });
              }
              if (commentData[10]) {
                setHodRejectionFormdata({
                  hodrejectReason: commentData[10].hodrejectReason || "",
                });
              }
              if (commentData[1]) {
                setElectricalFormData({
                  permitNo: workItem.workid || "",
                  certificateno: commentData[1].certificateno || "",
                  plantArea: commentData[1].plantArea || "",
                  equipmentTagNo: commentData[1].equipmentTagNo || "",

                  jobLocation: commentData[1].jobLocation || "",
                  contractorName: commentData[1].contractorName || "",
                  numberOfWorkers: commentData[1].numberOfWorkers || "",
                  name: commentData[1].name || "",
                  splInstructions: commentData[1].splInstructions || "",

                  signature: commentData[1].signature || "",
                  date: commentData[1].date || "",
                  time: commentData[1].time || "",
                  normalSupply: commentData[1].normalSupply || "",

                  alternativeSupply: commentData[1].alternativeSupply || "",
                  switchesOut: commentData[1].switchesOut || "",
                  powerFuseRemoved: commentData[1].powerFuseRemoved || "",
                  controlFusesRemoved: commentData[1].controlFusesRemoved || "",

                  breakerRackedOut: commentData[1].breakerRackedOut || "",
                  tagsProvided: commentData[1].tagsProvided || "",
                  terminalEarthed: commentData[1].terminalEarthed || "",
                  earthContinuityChecked:
                    commentData[1].earthContinuityChecked || "",

                  useElectricalGloves: commentData[1].useElectricalGloves || "",
                  other: commentData[1].other || "",
                  applicantName: commentData[1].applicantName || "",
                  fieldTwo: commentData[1].fieldTwo || "",

                  applicantdate: commentData[1].applicantdate || "",
                  applicanttime: commentData[1].applicanttime || "",
                  authoriserName: commentData[1].authoriserName || "",
                  authoriserfieldTwo: commentData[1].authoriserfieldTwo || "",

                  authoriserDate: commentData[1].authoriserDate || "",
                  authoriserTime: commentData[1].authoriserTime || "",
                  holderName: commentData[1].holderName || "",
                  holderSign: commentData[1].holderSign || "",

                  holderDate: commentData[1].holderDate || "",
                  holderTime: commentData[1].holderTime || "",
                  extapplicantname: commentData[1].extapplicantname || "",
                  extapplicantsign: commentData[1].extapplicantsign || "",

                  extauthorisedname: commentData[1].extauthorisedname || "",
                  extauthorisedsign: commentData[1].extauthorisedsign || "",
                  extextenddate: commentData[1].extextenddate || "",
                  extextendtime: commentData[1].extextendtime || "",

                  extapplicantname1: commentData[1].extapplicantname1 || "",
                  extapplicantsign1: commentData[1].extapplicantsign1 || "",
                  extauthorisedname1: commentData[1].extauthorisedname1 || "",
                  extauthorisedsign1: commentData[1].extauthorisedsign1 || "",

                  extextenddate1: commentData[1].extextenddate1 || "",
                  extextendtime1: commentData[1].extextendtime1 || "",
                  extapplicantname2: commentData[1].extapplicantname2 || "",
                  extapplicantsign2: commentData[1].extapplicantsign2 || "",
                  extauthorisedname2: commentData[1].extauthorisedname2 || "",

                  extauthorisedsign2: commentData[1].extauthorisedsign2 || "",
                  extextenddate2: commentData[1].extextenddate2 || "",
                  extextendtime2: commentData[1].extextendtime2 || "",
                  jobAuthrosiername: commentData[1].jobAuthrosiername || "",

                  jobAuthrosiersign: commentData[1].jobAuthrosiersign || "",
                  jobAuthrosierdate: commentData[1].jobAuthrosierdate || "",
                  jobAuthrosiertime: commentData[1].jobAuthrosiertime || "",
                  jobApplicantname: commentData[1].jobApplicantname || "",

                  jobApplicantsign: commentData[1].jobApplicantsign || "",
                  jobApplicantdate: commentData[1].jobApplicantdate || "",
                  jobApplicanttime: commentData[1].jobApplicanttime || "",
                  jobholdername: commentData[1].jobholdername || "",

                  jobholdersign: commentData[1].jobholdersign || "",
                  jobholderdate: commentData[1].jobholderdate || "",
                  jobholdertime: commentData[1].jobholdertime || "",
                });
              }
              if (commentData[2]) {
                setHeavyLiftFormData({
                  permitNo: workItem.workid || "",
                  certificateNo: commentData[2].certificateNo || "",
                  location: commentData[2].location || "",
                  date: commentData[2].date || "",

                  time: commentData[2].time || "",
                  descriptionOfLoad: commentData[2].descriptionOfLoad || "",
                  weightOfLoad: commentData[2].weightOfLoad || "",
                  dimensions: commentData[2].dimensions || "",

                  crane: commentData[2].crane || "",
                  type: commentData[2].type || "",
                  model: commentData[2].model || "",
                  person: commentData[2].person || "",

                  maxOperatingRadius: commentData[2].maxOperatingRadius || "",
                  mainBoomLength: commentData[2].mainBoomLength || "",
                  jibLength: commentData[2].jibLength || "",
                  jibOffset: commentData[2].jibOffset || "",

                  attachments: commentData[2].attachments || "",
                  counterweights: commentData[2].counterweights || "",
                  verticalClearance: commentData[2].verticalClearance || "",
                  drivingLicense: commentData[2].drivingLicense || "",

                  medicalFitness: commentData[2].medicalFitness || "",
                  certifiedTraining: commentData[2].certifiedTraining || "",
                  craneOperatorName: commentData[2].craneOperatorName || "",
                  craneOperatorSign: commentData[2].craneOperatorSign || "",

                  obstructions: commentData[2].obstructions || "",
                  distanceFromPowerLines:
                    commentData[2].distanceFromPowerLines || "",
                  groundStability: commentData[2].groundStability || "",
                  undergroundUtilities:
                    commentData[2].undergroundUtilities || "",

                  woodenStoppers: commentData[2].woodenStoppers || "",
                  liftingCapacity: commentData[2].liftingCapacity || "",
                  calweightOfLoad: commentData[2].calweightOfLoad || "",
                  totalWeightOfAccessories:
                    commentData[2].totalWeightOfAccessories || "",

                  totalWeightOfLift: commentData[2].totalWeightOfLift || "",
                  authorisedEngineerSign:
                    commentData[2].authorisedEngineerSign || "",
                  authorisedEngineerName:
                    commentData[2].authorisedEngineerName || "",
                });
              }
              if (commentData[3]) {
                const initialRadioactiveSubstancee =
                  commentData[3].radioactiveSubstance === "sealed"
                    ? "sealed"
                    : "unsealed";
                setRadiographyFormData({
                  radioactiveSubstance: initialRadioactiveSubstancee,
                  sign: commentData[3].sign || "",
                  name: commentData[3].name || "",
                  date: commentData[3].date || "",
                  plant: commentData[3].plant || "",
                  location: commentData[3].location || "",
                  certificateNo: commentData[3].certificateNo || "",

                  permitNo: commentData[3].permitNo || "",
                  reason: commentData[3].reason || "",
                  radiosouce: commentData[3].radiosouce || "",
                  xrayMake: commentData[3].xrayMake || "",
                  xrayType: commentData[3].xrayType || "",
                  maxTubeVoltage: commentData[3].maxTubeVoltage || "",
                  totalActivity: commentData[3].totalActivity || "",
                  halfLife: commentData[3].halfLife || "",
                  isotope: commentData[3].isotope || "",
                  alpha: commentData[3].alpha || "",

                  beta: commentData[3].beta || "",
                  gamma: commentData[3].gamma || "",
                  neutron: commentData[3].neutron || "",
                  specialPrecautions: commentData[3].specialPrecautions || "",
                  permitAuthorisersign:
                    commentData[3].permitAuthorisersign || "",
                  permitAuthorisername:
                    commentData[3].permitAuthorisername || "",

                  permitAuthoriserdate:
                    commentData[3].permitAuthoriserdate || "",
                  permitAuthorisertime:
                    commentData[3].permitAuthorisertime || "",
                  permitHoldersign: commentData[3].permitHoldersign || "",
                  permitHoldername: commentData[3].permitHoldername || "",
                  permitHolderdate: commentData[3].permitHolderdate || "",
                  permitHoldertime: commentData[3].permitHoldertime || "",
                });
              }
            }
          }
        })
        .catch((error) => {
          toast.error("Some issue occurred. Please check...");
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleTimeChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      timeTo: value,
    }));
  };

  const handleTimeFromChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      timeFrom: value,
    }));
  };

  const handlePermitTimeChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      permitauthtimefrom: value,
    }));
  };

  const handlePermitTimeToChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      permitauthtimeto: value,
    }));
  };

  const handlePermitwcapplicanttimeChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      permitwcapplicanttime: value,
    }));
  };

  const handlePermitwcAuthorisertimeChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      permitwcAuthorisertime: value,
    }));
  };

  const handlePermitwncholdertimeChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      permitwncholdertime: value,
    }));
  };

  const handlePermitwncapplicanttimeChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      permitwncapplicanttime: value,
    }));
  };

  const handlePermitwncAuthorisertimeChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      permitwncAuthorisertime: value,
    }));
  };

  const handlePermitwcholdertimeChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      permitwcholdertime: value,
    }));
  };

  useEffect(() => {
    const fetchStatusOptions = async () => {
      setLoading(true);
      const apiEndpoint = `${apiUrl}workprocessdet/optionsbystepcode/${selectedStep}`;
      try {
        const response = await axios.get(apiEndpoint, { headers });
        if (response.data.cd === 1) {
          toast.error(response.data.description);
          setStatusOptions([]);
        } else {
          let newTab = "open";
          newTab = response.data[0].defaultscreen;
          if (newTab == "?") {
            if (
              selectedWorklistPUser === 103 ||
              selectedWorklistPUser === 104
            ) {
              newTab = "electrical";
            } else if (
              selectedWorklistPUser === 105 ||
              selectedWorklistPUser === 106
            ) {
              newTab = "saftey";
            } else if (
              selectedWorklistPUser === 107 ||
              selectedWorklistPUser === 108
            ) {
              newTab = "maintance";
            }
          } else {
            setVisibleTabs((prevTabs) => Array.from(new Set(["open", newTab])));
            setActiveTab(newTab);
          }
          setVisibleTabs((prevTabs) => Array.from(new Set(["open", newTab])));
          setActiveTab(newTab);

          const options = response.data.map((item) => ({
            label: item.nextoption,
            value: item.id,
          }));
          setStatusOptions(options);
        }
      } catch (error) {
        toast.error("Failed to fetch status options.");
      } finally {
        setLoading(false);
      }
    };

    fetchStatusOptions();
  }, [apiUrl]);

  const validateFields = () => {
    let newErrors = {};

    // Check if "Electrical-Reject" tab is active and reason is empty
    if (
      visibleTabs.includes("ele-reject") &&
      (!elerejectFormData.elerejectReason ||
        elerejectFormData.elerejectReason.trim() === "")
    ) {
      newErrors.elerejectReason = "Please enter a rejection reason.";
    }

    if (
      visibleTabs.includes("safety-reject") &&
      (!safteyrejectFormData.safteyrejectReason ||
        safteyrejectFormData.safteyrejectReason.trim() === "")
    ) {
      newErrors.safteyrejectReason = "Please enter a rejection reason.";
    }
    if (
      visibleTabs.includes("radio-reject") &&
      (!radiorejectFormData.radiorejectReason ||
        radiorejectFormData.radiorejectReason.trim() === "")
    ) {
      newErrors.radiorejectReason = "Please enter a rejection reason.";
    }
    if (
      visibleTabs.includes("hod-reject") &&
      (!hodrejectFormData.hodrejectReason ||
        hodrejectFormData.hodrejectReason.trim() === "")
    ) {
      newErrors.hodrejectReason = "Please enter a rejection reason.";
    }
    if (
      visibleTabs.includes("ptw-reject") &&
      (!rejectFormData.rejectReason ||
        rejectFormData.rejectReason.trim() === "")
    ) {
      newErrors.rejectReason = "Please enter a rejection reason.";
    }
    if (!formData.workComments || formData.workComments.trim() === "") {
      newErrors.workComments = "Please enter your comments.";
    }
    if (
      visibleTabs.includes("close") &&
      (!closeFormData.closeReason || closeFormData.closeReason.trim() === "")
    ) {
      newErrors.closeReason = "Please enter a Close reason.";
    }

    // ** Validate Department Selection if nextUser is true **
    if (
      nextUser &&
      Object.values(selectedDepartments).every((value) => !value)
    ) {
      newErrors.selectedDepartments =
        "Please select at least one Employee for  department.";
    }

    if (nextUser && Object.values(selectedEmployees).every((value) => !value)) {
      newErrors.selectedDepartments =
        "Please select at least one Employee for  department.";
    }

    if (selectedStep === 7) {
      if (!formData.dateTo) newErrors.dateTo = "Date To is required";
      if (!formData.timeTo) newErrors.timeTo = "Time To is required";
    }

    // Combine and validate full datetime if all fields are provided
    if (
      formData.dateFrom &&
      formData.dateTo &&
      formData.timeFrom &&
      formData.timeTo
    ) {
      const fromDateTime = new Date(
        `${formData.dateFrom}T${formData.timeFrom}`,
      );
      const toDateTime = new Date(`${formData.dateTo}T${formData.timeTo}`);

      if (toDateTime <= fromDateTime) {
        newErrors.timeTo = "To date/time must be greater than From date/time.";
      }
    }

    if (formData.permitauthtimefrom && formData.permitauthtimeto) {
      const fromTime = new Date(`1970-01-01T${formData.permitauthtimefrom}`);
      const toTime = new Date(`1970-01-01T${formData.permitauthtimeto}`);

      if (toTime <= fromTime) {
        newErrors.permitauthtimeto = "To Time must be greater than From Time.";
      }
    }

    if (
      formData.permitauthdatefrom &&
      formData.permitauthdateto &&
      formData.permitauthtimefrom &&
      formData.permitauthtimeto
    ) {
      const fromDateTime = new Date(
        `${formData.permitauthdatefrom}T${formData.permitauthtimefrom}`,
      );
      const toDateTime = new Date(
        `${formData.permitauthdateto}T${formData.permitauthtimeto}`,
      );

      if (toDateTime <= fromDateTime) {
        newErrors.permitauthdateto =
          "Permit end date/time must be after start date/time.";
      }
    }

    setErrors(newErrors); // Update errors state

    // Return true if there are NO errors (form is valid), false otherwise
    return Object.keys(newErrors).length === 0;
  };

  const getLabelFromValue = (value, options) => {
    const option = options.find((option) => option.value === value);
    return option ? option.label : value;
  };

  const sendNotification = async (workId, assignedUser) => {
    const user = getLabelFromValue(assignedUser, assignedUserOptions);

    try {
      const response = await axios.post(
        `${notificationUrl}?userid=${user}&taskcode=${workId}`,
        {}, // Empty body since you are using query params
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      // Uncomment and adjust if needed
      // if (response.data.cd === 1) {
      //   toast.error(response.data.description);
      // } else {
      //   toast.success(response.data.description);
      //   onHide();
      //   setRefresh(true);
      // }
    } catch (error) {
      //toast.error('Some issue occurred. Please check.');
    } finally {
      setLoading(false);
    }
    toast.success("Notification is sent to Assigned User.");
  };

  const handleSubmit = async () => {
    if (!validateFields()) {
      toast.warning("Please fill in the required fields before submitting!");
      setLoading(false);
      return;
    }
    setLoading(true);
    const finalComment = `${userName}: ${formData.workComments}`;
    const finalFormData = {
      ...formData,
      workComments: finalComment,
    };
    const selectedEmployeeList = Object.keys(selectedEmployees)
      .filter((empId) => selectedEmployees[empId]) // Get only checked employees
      .join(",");

    const selectedDepartmentList = Object.keys(selectedDepartments)
      .filter((divId) => selectedDepartments[divId]) // Get only checked employees
      .join(",");

    const workDoc = filePaths.map((file) => ({
      doc: file.doc,
      name: file.name,
      type: file.type,
    }));

    const formattedFormData = {
      0: finalFormData,
      1: electricalFormData,
      2: heavyLiftFormData,
      3: radiographyFormData,
      4: rejectFormData,
      5: publishFormData,
      6: hodVarificationReasonFormData,
      7: elerejectFormData,
      8: safteyrejectFormData,
      9: radiorejectFormData,
      10: hodrejectFormData,
    };

    // If no errors, proceed with the API call
    const apiEndpoint = `${apiUrl}worklist`;

    const requestData = {
      workItem: {
        id: workitem.id,
        workid: workId,
        type: workitem.type,
        status: workitem.status,
        comment: JSON.stringify(formattedFormData),
        createuser: workitem.createuser,
        createdatetime: workitem.createdatetime,
        lastupdateuser: empCode,
        lastupdatedatetime: workitem.lastupdatedatetime,
        expectedcomdatetime: workitem.expectedcomdatetime,
        division: selectedDepartmentList,
        assignedusers: selectedEmployeeList,
      },
      workList: {
        id: workList.id,
        workid: workId,
        assigneduser: empCode,
        previoususer: empCode,
        stepcd: workList.stepcd,
      },
      workListHist: {
        userName: userName,
      },
      workProcessDet: {
        id: workProcessdto.id,
        wpcode: workProcessdto.wpcode,
        stepcd: workProcessdto.stepcd,
        stepname: workProcessdto.stepname,
        defaultscreen: workProcessdto.defaultscreen,
        nextoption: workProcessdto.nextoption,
        nextscreen: workProcessdto.nextscreen,
        nextuser: workProcessdto.nextuser,
        nextstep: workProcessdto.nextstep,
        status: workProcessdto.status,
        statusval: workProcessdto.statusval,
      },
      workDoc: workDoc,
    };

    try {
      const response = await axios.put(apiEndpoint, requestData, {
        headers: {
          Authorization: `Bearer ${dbTokenData}`,
          "Content-Type": "application/json",
          dbMaster: "",
          "Selected-Employees": selectedEmployeeList,
          WorklistId: selectedWorklistId,
          user: empCode,
        },
      });

      if (response.data.cd === 1) {
        setLoading(false);
        toast.error(response.data.description);
      } else {
        setLoading(false);
        toast.success("Updated Successfully..");
        fetchWorkItemData();
        onHide();
        response.data.forEach((item) => {
          sendNotification(item.workid, item.assigneduser);
        });
      }
    } catch (error) {
      setLoading(false);
      toast.error("Some Issue Please Check..");
    } finally {
      setLoading(false);
    }
  };

  const handleViewDocuments = () => {
    setIsSidebarOpen(true);
  };

  const handleCloseSidebar = () => {
    setIsSidebarOpen(false);
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <>
      <GlobalStyles
        styles={{
          ".workitem-open": {
            width: "100%",
            boxSizing: "border-box",
            color: "#1B2733",
            backgroundColor: "#FFFFFF",
          },
          ".workitem-open .edit-popupmodal-maindiv": {
            width: "100%",
            boxSizing: "border-box",
            backgroundColor: "#FFFFFF",
          },
          ".workitem-open .edit-popupmodal-header": {
            width: "100%",
            boxSizing: "border-box",
            backgroundColor: "#FFFFFF",
          },
          ".workitem-open .popupmodal-tabs": {
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",
            gap: 0,
            margin: "0 0 14px",
            padding: "0 2px",
            borderBottom: "1px solid #DCE5EE",
            backgroundColor: "#FFFFFF",
            overflowX: "auto",
            overflowY: "hidden",
          },
          ".workitem-open .popupmodal-tabs .nav-item": {
            margin: 0,
          },
          ".workitem-open .popupmodal-tabs .nav-link": {
            position: "relative",
            border: "0 !important",
            borderRadius: "0 !important",
            backgroundColor: "#FFFFFF !important",
            color: "#687787 !important",
            fontSize: "13px",
            fontWeight: 600,
            padding: "10px 15px 11px",
            margin: 0,
            whiteSpace: "nowrap",
            transition: "background-color .18s ease, color .18s ease",
          },
          ".workitem-open .popupmodal-tabs .nav-link:hover": {
            color: "#123B5D !important",
            backgroundColor: "#F6F9FC !important",
          },
          ".workitem-open .popupmodal-tabs .nav-link.active": {
            color: "#123B5D !important",
            backgroundColor: "#EEF5FB !important",
            fontWeight: 700,
          },
          ".workitem-open .popupmodal-tabs .nav-link.active::after": {
            content: '""',
            position: "absolute",
            left: 0,
            right: 0,
            bottom: -1,
            height: "3px",
            backgroundColor: "#123B5D",
            borderRadius: "3px 3px 0 0",
          },
          ".workitem-open .popupmodal-tabs + .tab-content": {
            width: "100%",
            margin: 0,
          },
          ".workitem-open .tab-content > .tab-pane": {
            padding: 0,
          },
          ".workitem-open .form-container": {
            width: "100%",
            boxSizing: "border-box",
            border: "1px solid #D7E0E9",
            borderRadius: "10px",
            padding: "14px",
            backgroundColor: "#FFFFFF",
          },
          ".workitem-open .logo-container": {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "42px",
            marginBottom: "4px",
          },
          ".workitem-open .logo-container img": {
            maxWidth: "160px !important",
            height: "auto !important",
            objectFit: "contain",
          },
          ".workitem-open .header-section": {
            width: "100%",
          },
          ".workitem-open .center-heading": {
            margin: "6px 0 12px !important",
            color: "#123B5D",
            fontSize: "22px !important",
            fontWeight: "700 !important",
            lineHeight: 1.2,
            textAlign: "center",
            letterSpacing: "0.2px",
          },
          ".workitem-open .safety-table, .workitem-open .work-table, .workitem-open .precautions-table, .workitem-open .ppe-table, .workitem-open .electrical-certificate-form__table, .workitem-open .electrical-certificate-form__signature-table, .workitem-open .heavylift-form-table, .workitem-open .department-certificate-form__table, .workitem-open .permit-return-table":
            {
              width: "100%",
              borderCollapse: "separate",
              borderSpacing: 0,
              border: "1px solid #D7E0E9",
              borderRadius: "8px",
              overflow: "hidden",
              backgroundColor: "#FFFFFF",
              fontSize: "13px",
            },
          ".workitem-open .safety-table td": {
            borderRight: "1px solid #E0E7EF",
            borderBottom: "1px solid #E0E7EF",
            padding: "10px 12px",
            verticalAlign: "middle",
            backgroundColor: "#FAFCFE",
            color: "#33485C",
          },
          ".workitem-open .safety-table td:nth-child(2n)": {
            fontWeight: 600,
            color: "#123B5D",
          },
          ".workitem-open .work-table td, .workitem-open .precautions-table td, .workitem-open .ppe-table td, .workitem-open .electrical-certificate-form__table td, .workitem-open .electrical-certificate-form__signature-table td, .workitem-open .heavylift-form-table td, .workitem-open .department-certificate-form__table td, .workitem-open .permit-return-table td":
            {
              borderRight: "1px solid #E0E7EF",
              borderBottom: "1px solid #E0E7EF",
              padding: "8px 10px",
              verticalAlign: "middle",
              backgroundColor: "#FFFFFF",
              color: "#33485C",
            },
          ".workitem-open .safety-table tr:last-child td, .workitem-open .work-table tr:last-child td, .workitem-open .precautions-table tr:last-child td, .workitem-open .ppe-table tr:last-child td, .workitem-open .electrical-certificate-form__table tr:last-child td, .workitem-open .electrical-certificate-form__signature-table tr:last-child td, .workitem-open .heavylift-form-table tr:last-child td, .workitem-open .department-certificate-form__table tr:last-child td, .workitem-open .permit-return-table tr:last-child td":
            {
              borderBottom: 0,
            },
          ".workitem-open .safety-table td:last-child, .workitem-open .work-table td:last-child, .workitem-open .precautions-table td:last-child, .workitem-open .ppe-table td:last-child, .workitem-open .electrical-certificate-form__table td:last-child, .workitem-open .electrical-certificate-form__signature-table td:last-child, .workitem-open .heavylift-form-table td:last-child, .workitem-open .department-certificate-form__table td:last-child, .workitem-open .permit-return-table td:last-child":
            {
              borderRight: 0,
            },
          ".workitem-open .precautions-table th, .workitem-open .ppe-table th, .workitem-open .electrical-certificate-form__table th, .workitem-open .electrical-certificate-form__signature-table th, .workitem-open .heavylift-form-table th, .workitem-open .department-certificate-form__table th, .workitem-open .permit-return-table th":
            {
              backgroundColor: "#123B5D !important",
              color: "#FFFFFF !important",
              borderRight: "1px solid rgba(255,255,255,0.18)",
              borderBottom: "1px solid rgba(255,255,255,0.22)",
              padding: "9px 10px",
              fontSize: "12px",
              fontWeight: 700,
              textAlign: "left",
              verticalAlign: "middle",
            },
          ".workitem-open .precautions-table th:last-child, .workitem-open .ppe-table th:last-child, .workitem-open .electrical-certificate-form__table th:last-child, .workitem-open .electrical-certificate-form__signature-table th:last-child, .workitem-open .heavylift-form-table th:last-child, .workitem-open .department-certificate-form__table th:last-child, .workitem-open .permit-return-table th:last-child":
            {
              borderRight: 0,
            },
          ".workitem-open .work-description-section, .workitem-open .precautions-section, .workitem-open .ppe-section, .workitem-open .permit-signatures, .workitem-open .electrical-certificate-form, .workitem-open .heavylift-form-container, .workitem-open .radiography-form, .workitem-open .electrical-certificate-form__group, .workitem-open .file-upload-section":
            {
              marginTop: "14px",
              border: "1px solid #D7E0E9",
              borderRadius: "10px",
              overflow: "hidden",
              backgroundColor: "#FFFFFF",
            },
          ".workitem-open .work-description-section h3, .workitem-open .ppe-section h3, .workitem-open .permit-signatures h3, .workitem-open .heavylift-section-title, .workitem-open .electrical-certificate-form__heading, .workitem-open .electrical-certificate-form__section h3, .workitem-open .radiography-section h3, .workitem-open .electrical-certificate-form__group > h3, .workitem-open .file-upload-section h3":
            {
              margin: "0 !important",
              padding: "10px 13px",
              backgroundColor: "#EEF4F8",
              color: "#123B5D",
              fontSize: "15px !important",
              lineHeight: 1.35,
              fontWeight: "700 !important",
              borderBottom: "1px solid #DCE4EC",
            },
          ".workitem-open .permit-return-section h3": {
            margin: "0 0 8px !important",
            padding: "10px 13px",
            backgroundColor: "#EEF4F8",
            color: "#123B5D",
            fontSize: "14px !important",
            lineHeight: 1.35,
            fontWeight: "700 !important",
            border: "1px solid #D7E0E9",
            borderRadius: "8px",
          },
          ".workitem-open .work-table label, .workitem-open .precautions-table label, .workitem-open .ppe-table label, .workitem-open .permit-return-table label, .workitem-open .electrical-certificate-form__label, .workitem-open .radiography-form-row label, .workitem-open .heavylift-form-label, .workitem-open .department-certificate-form__group label":
            {
              color: "#33485C",
              fontSize: "12.5px",
              fontWeight: 600,
            },
          '.workitem-open .form-container input:not([type="radio"]):not([type="checkbox"]), .workitem-open .form-container textarea, .workitem-open .form-container select, .workitem-open .electrical-certificate-form input:not([type="radio"]):not([type="checkbox"]), .workitem-open .electrical-certificate-form textarea, .workitem-open .heavylift-form-container input:not([type="radio"]):not([type="checkbox"]), .workitem-open .radiography-form input:not([type="radio"]):not([type="checkbox"]), .workitem-open .radiography-form textarea':
            {
              width: "100%",
              boxSizing: "border-box",
              minHeight: "38px",
              border: "1px solid #C9D6E2",
              borderRadius: "7px",
              padding: "8px 10px",
              backgroundColor: "#FFFFFF",
              color: "#1E2D3A",
              fontSize: "13px",
              outline: "none",
              transition: "border-color .18s ease, box-shadow .18s ease",
            },
          '.workitem-open .form-container input:not([type="radio"]):not([type="checkbox"]):focus, .workitem-open .form-container textarea:focus, .workitem-open .form-container select:focus, .workitem-open .electrical-certificate-form input:not([type="radio"]):not([type="checkbox"]):focus, .workitem-open .electrical-certificate-form textarea:focus, .workitem-open .heavylift-form-container input:not([type="radio"]):not([type="checkbox"]):focus, .workitem-open .radiography-form input:not([type="radio"]):not([type="checkbox"]):focus, .workitem-open .radiography-form textarea:focus':
            {
              borderColor: "#7DA6C4",
              boxShadow: "0 0 0 3px rgba(18,59,93,0.10)",
            },
          ".workitem-open .form-container textarea, .workitem-open .electrical-certificate-form textarea, .workitem-open .radiography-form textarea":
            {
              minHeight: "90px",
              resize: "vertical",
            },
          '.workitem-open input[type="radio"], .workitem-open input[type="checkbox"]':
            {
              accentColor: "#123B5D",
            },
          ".workitem-open .react-time-picker": {
            width: "100% !important",
            minWidth: 0,
            height: "38px",
            boxSizing: "border-box",
            border: "1px solid #C9D6E2",
            borderRadius: "7px",
            backgroundColor: "#FFFFFF",
            display: "flex",
            alignItems: "center",
          },
          ".workitem-open .react-time-picker__wrapper": {
            width: "100%",
            minHeight: "36px",
            height: "36px",
            boxSizing: "border-box",
            border: "0 !important",
            padding: "0 8px",
            display: "flex",
            alignItems: "center",
          },
          ".workitem-open .react-time-picker__inputGroup": {
            flex: 1,
            minWidth: 0,
            display: "flex !important",
            alignItems: "center",
            fontSize: "13px",
          },
          ".workitem-open .react-time-picker__inputGroup__input": {
            width: "auto !important",
            minWidth: "2.2ch",
            minHeight: "0 !important",
            height: "auto !important",
            border: "0 !important",
            borderRadius: "0 !important",
            padding: "0 !important",
            boxShadow: "none !important",
            backgroundColor: "transparent !important",
            fontSize: "13px !important",
            color: "#243746 !important",
            outline: "none !important",
          },
          ".workitem-open .react-time-picker__inputGroup__hour, .workitem-open .react-time-picker__inputGroup__minute":
            {
              width: "2.4em !important",
            },
          ".workitem-open .react-time-picker__inputGroup__amPm": {
            width: "3.6em !important",
            minWidth: "3.6em !important",
          },
          ".workitem-open .react-time-picker__clock-button": {
            display: "none",
          },
          ".workitem-open .react-time-picker__clear-button": {
            display: "none",
          },
          ".workitem-open .react-time-picker__inputGroup__leadingZero": {
            color: "#8A99A8",
          },
          ".workitem-open .reject-tab-content": {
            padding: "14px",
            border: "1px solid #D7E0E9",
            borderRadius: "10px",
            backgroundColor: "#FFFFFF",
          },
          ".workitem-open .reject-label": {
            display: "block",
            marginBottom: "7px",
            color: "#33485C",
            fontSize: "12.5px",
            fontWeight: 600,
          },
          ".workitem-open .reject-textarea": {
            width: "100%",
            minHeight: "150px",
            border: "1px solid #C9D6E2",
            borderRadius: "8px",
            padding: "10px 12px",
            resize: "vertical",
            color: "#1B2733",
            backgroundColor: "#FFFFFF",
            outline: "none",
            boxSizing: "border-box",
            fontSize: "13px",
          },
          ".workitem-open .reject-textarea:focus": {
            borderColor: "#7DA6C4 !important",
            boxShadow: "0 0 0 3px rgba(18,59,93,0.10)",
          },
          ".workitem-open .error-border": {
            borderColor: "#D32F2F !important",
          },
          '.workitem-open .error-text, .workitem-open .error-textarea, .workitem-open .form-container span[style*="color: red"]':
            {
              color: "#D32F2F !important",
              fontSize: "11.5px",
              display: "block",
              marginTop: "4px",
              lineHeight: 1.35,
            },
          ".workitem-open .popupmodal-footer": {
            display: "grid",
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
            gap: "12px",
            alignItems: "start",
            marginTop: "14px",
            paddingTop: "14px",
            borderTop: "1px solid #DCE5EE",
          },
          ".workitem-open .permit-return-section": {
            minWidth: 0,
          },
          ".workitem-open .permit-return-section textarea": {
            width: "100%",
            minHeight: "78px",
            boxSizing: "border-box",
            padding: "8px 10px",
            border: "1px solid #C9D6E2",
            borderRadius: "7px",
            resize: "vertical",
            outline: "none",
            fontSize: "12.5px",
            color: "#1E2D3A",
            backgroundColor: "#FFFFFF",
          },
          ".workitem-open .button-section": {
            gridColumn: "1 / -1",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "8px",
            paddingTop: "2px",
          },
          ".workitem-open .button-section button": {
            minHeight: "38px",
            minWidth: "94px",
            padding: "0 15px",
            borderRadius: "7px",
            border: "1px solid transparent",
            fontSize: "12.5px",
            fontWeight: 600,
            cursor: "pointer",
            transition:
              "background-color .18s ease, box-shadow .18s ease, border-color .18s ease",
          },
          ".workitem-open .print-btn": {
            backgroundColor: "#FFFFFF",
            borderColor: "#C7D4E1 !important",
            color: "#123B5D",
          },
          ".workitem-open .print-btn:hover": {
            backgroundColor: "#F2F6FA",
            borderColor: "#9FB5CA !important",
          },
          ".workitem-open .submit-btn": {
            backgroundColor: "#16845B",
            color: "#FFFFFF",
          },
          ".workitem-open .submit-btn:hover:not(:disabled)": {
            backgroundColor: "#126F4C",
            boxShadow: "0 4px 12px rgba(22,132,91,0.18)",
          },
          ".workitem-open .cancel-btn": {
            backgroundColor: "#D64545",
            color: "#FFFFFF",
          },
          ".workitem-open .cancel-btn:hover": {
            backgroundColor: "#BC3535",
            boxShadow: "0 4px 12px rgba(214,69,69,0.18)",
          },
          ".workitem-open .button-section button:disabled": {
            opacity: 0.5,
            cursor: "not-allowed",
          },
          ".workitem-open .electrical-certificate-form__group, .workitem-open .department-certificate-form__group, .workitem-open .radiography-form-row, .workitem-open .radiography-input-group":
            {
              marginBottom: "9px",
            },
          ".workitem-open .electrical-certificate-form__subtitle, .workitem-open .heavylift-form-note":
            {
              color: "#64748B",
              fontSize: "12px",
            },
          ".workitem-open .radiography-authorization-box": {
            padding: "12px",
            border: "1px solid #D7E0E9",
            borderRadius: "8px",
            backgroundColor: "#FFFFFF",
            marginTop: "10px",
          },
          ".workitem-open .radiography-authorization-box p": {
            margin: "0 0 10px",
            color: "#526273",
            fontSize: "12.5px",
            lineHeight: 1.5,
          },
          ".workitem-open .form-container > .work-description-section:first-of-type":
            {
              marginTop: "0",
            },
          "@media (max-width: 900px)": {
            ".workitem-open .popupmodal-tabs": {
              marginBottom: "10px",
            },
            ".workitem-open .popupmodal-footer": {
              gridTemplateColumns: "1fr",
            },
            ".workitem-open .button-section": {
              gridColumn: "auto",
            },
            ".workitem-open .safety-table, .workitem-open .work-table, .workitem-open .precautions-table, .workitem-open .ppe-table, .workitem-open .electrical-certificate-form__table, .workitem-open .electrical-certificate-form__signature-table, .workitem-open .heavylift-form-table, .workitem-open .department-certificate-form__table, .workitem-open .permit-return-table":
              {
                minWidth: "720px",
              },
            ".workitem-open .work-description-section, .workitem-open .precautions-section, .workitem-open .ppe-section, .workitem-open .permit-signatures, .workitem-open .electrical-certificate-form, .workitem-open .heavylift-form-container, .workitem-open .radiography-form":
              {
                overflowX: "auto",
              },
          },
          "@media (max-width: 700px)": {
            ".workitem-open .popupmodal-tabs .nav-link": {
              padding: "9px 11px 10px",
              fontSize: "12px",
            },
            ".workitem-open .form-container": {
              padding: "9px",
            },
            ".workitem-open .center-heading": {
              fontSize: "18px !important",
            },
          },
        }}
      />
      <div className="workitem-open edit-popupmodal-maindiv">
        {/* Header */}
        <div className="edit-popupmodal-header">
          <div>
            <Tabs
              id="work-item-tabs"
              activeKey={activeTab}
              onSelect={handleTabChange}
              className="popupmodal-tabs"
            >
              {visibleTabs.includes("open") && (
                <Tab eventKey="open" title="Open">
                  <div ref={formRefs.open}>
                    <div className="form-container">
                      <div className="logo-container">
                        <img
                          src={orgImg}
                          alt="Organization Logo"
                          style={{
                            width: "130px",
                            height: "50px",
                            backgroundColor: "transparent",
                            borderRadius: "2px",
                          }}
                        />
                      </div>
                      <div className="header-section">
                        <h2 className="center-heading">PERMIT TO WORK</h2>
                        <table className="safety-table">
                          <tbody>
                            <tr>
                              <td>
                                {" "}
                                <input
                                  type="radio"
                                  name="workType"
                                  value="hotWork"
                                  checked={formData.workType === "hotWork"}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>Hot Work</td>
                              <td>
                                {" "}
                                <input
                                  type="radio"
                                  name="workType"
                                  value="coldWork"
                                  checked={formData.workType === "coldWork"}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>Cold Work</td>
                              <td>Permit No</td>
                              <td>
                                <input
                                  type="text"
                                  name="permitNo"
                                  value={formData.permitNo || ""}
                                  readonly
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div className="work-description-section">
                        <h3>Application and Work Description</h3>
                        <table className="work-table">
                          <tbody>
                            {/* First Row */}
                            <tr>
                              <td>
                                <label>Plant:</label>
                              </td>
                              <td>
                                {" "}
                                <PopupInputField
                                  type="text"
                                  name="plant"
                                  value={formData.plant || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <label>Date From:</label>
                              </td>
                              <td>
                                {" "}
                                <input
                                  type="date"
                                  name="dateFrom"
                                  value={formData.dateFrom || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <label>Date To:</label>
                              </td>
                              <td>
                                {" "}
                                <input
                                  type="date"
                                  name="dateTo"
                                  value={formData.dateTo || ""}
                                  style={{
                                    border: errors.dateTo
                                      ? "2px solid red"
                                      : "",
                                  }}
                                  onChange={handleChange}
                                />
                                {errors.dateTo && (
                                  <span style={{ color: "red" }}>
                                    {errors.dateTo}
                                  </span>
                                )}
                              </td>
                            </tr>

                            {/* Second Row */}
                            <tr>
                              <td>
                                <label>Location:</label>
                              </td>
                              <td>
                                {" "}
                                <PopupInputField
                                  type="text"
                                  name="location"
                                  value={formData.location || ""}
                                  onChange={handleChange}
                                />
                              </td>

                              <td>
                                <label>Time From:</label>
                              </td>
                              <td>
                                <TimePicker
                                  onChange={handleTimeFromChange}
                                  value={formData.timeFrom}
                                  format="h:mm a"
                                  disableClock={true}
                                  clearIcon={null}
                                />
                              </td>
                              <td>
                                <label>Time To:</label>
                              </td>
                              <td>
                                <TimePicker
                                  onChange={handleTimeChange}
                                  value={formData.timeTo}
                                  style={{
                                    border: errors.timeTo
                                      ? "2px solid red"
                                      : "",
                                  }}
                                  format="h:mm a"
                                  disableClock={true}
                                  clearIcon={null}
                                />
                                {errors.timeTo && (
                                  <span style={{ color: "red" }}>
                                    {errors.timeTo}
                                  </span>
                                )}
                              </td>
                            </tr>

                            {/* Fourth Row */}
                            <tr>
                              <td colSpan="6">
                                <label style={{ fontWeight: "bold" }}>
                                  Work Description:
                                </label>
                              </td>
                            </tr>
                            <tr>
                              <td colSpan="6">
                                <textarea
                                  rows="4"
                                  name="workDescription"
                                  value={formData.workDescription || ""}
                                  style={{ width: "100%" }}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>

                            {/* Fifth Row - Applicant Details */}
                            <tr>
                              <td colSpan="6">
                                <label style={{ fontWeight: "bold" }}>
                                  Applicant:
                                </label>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>Name:</label>
                              </td>
                              <td colSpan="2">
                                {" "}
                                <PopupInputField
                                  type="text"
                                  name="applicantName"
                                  value={formData.applicantName || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <label>Sign:</label>
                              </td>
                              <td colSpan="2">
                                {" "}
                                <PopupInputField
                                  type="text"
                                  name="applicantSign"
                                  value={formData.applicantSign || ""}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {/* Special Precautions Section */}
                      <div className="precautions-section">
                        <table className="precautions-table">
                          <thead>
                            <tr>
                              <th style={{ width: "20%" }}>
                                Safety Measures Taken By Operations
                              </th>
                              <th>Remarks</th>
                              <th>Special Precautions & Potential Hazards</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                Equipment is free from
                                Flammable/Hydrocarbon/Toxic gases
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="safety1"
                                  value={formData.safety1 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="hazard1"
                                  value={formData.hazard1 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>Equipment properly drained, cleaned</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="safety2"
                                  value={formData.safety2 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="hazard2"
                                  value={formData.hazard2 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>Water seal has been made</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="safety3"
                                  value={formData.safety3 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="hazard3"
                                  value={formData.hazard3 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>Bleeders have been opened</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="safety4"
                                  value={formData.safety4 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="hazard4"
                                  value={formData.hazard4 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>Nitrogen purging has been done</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="safety5"
                                  value={formData.safety5 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="hazard5"
                                  value={formData.hazard5 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>Radioactive sources protected</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="safety6"
                                  value={formData.safety6 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="hazard6"
                                  value={formData.hazard6 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>Name/Sign</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="safety7"
                                  value={formData.safety7 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="hazard7"
                                  value={formData.hazard7 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      {/* PPE, Fire Precautions, Gas Tests, Certificates */}
                      <div className="ppe-section">
                        <h3>
                          3. PPE, Fire Precautions, Gas Tests & Associated
                          Certificates
                        </h3>
                        <table className="ppe-table">
                          <thead>
                            <tr>
                              <th style={{ width: "15%" }}>
                                3A - PPE & Others
                              </th>
                              <th>Remarks</th>
                              <th style={{ width: "15%" }}>
                                3B - Fire Precautions & Gas Tests
                              </th>
                              <th>Remarks</th>
                              <th>3C - Certificates</th>
                              <th>Certificate Nos.</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Eye, Face & Ear Protection</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="ppe1"
                                  value={formData.ppe1 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>Competent Fire Watcher</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="firePrecaution1"
                                  value={formData.firePrecaution1 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>Confined Space Entry</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="certificate1"
                                  value={formData.certificate1 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>Head Protection</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="ppe2"
                                  value={formData.ppe2 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>Fire Extinguishers</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="firePrecaution2"
                                  value={formData.firePrecaution2 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>LOTO</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="certificate2"
                                  value={formData.certificate2 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>Body Protection, Full Body Safety hamess</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="ppe3"
                                  value={formData.ppe3 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>Pressure Fire Hose</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="firePrecaution3"
                                  value={formData.firePrecaution3 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>Electrical</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="certificate3"
                                  value={formData.certificate3 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>Respiratory Protection (BA set)</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="ppe4"
                                  value={formData.ppe4 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>Fire Tender</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="firePrecaution4"
                                  value={formData.firePrecaution4 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>Working at Height</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="certificate4"
                                  value={formData.certificate4 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>Leg Protection</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="ppe5"
                                  value={formData.ppe5 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>Screen off Area</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="firePrecaution5"
                                  value={formData.firePrecaution5 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>Excavation/Scaffding</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="certificate5"
                                  value={formData.certificate5 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>portable CO monitor</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="ppe6"
                                  value={formData.ppe6 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>Explosive Test</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="firePrecaution6"
                                  value={formData.firePrecaution6 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>Heavy Lift/Hydra</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="certificate6"
                                  value={formData.certificate6 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>Roof ledder/Gas cutting Sets</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="ppe7"
                                  value={formData.ppe7 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>Carbone Monaxide Test</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="firePrecaution7"
                                  value={formData.firePrecaution7 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>Road Closure</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="certificate7"
                                  value={formData.certificate7 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Safe means of acess/Scaffolding/Enclosures
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="ppe8"
                                  value={formData.ppe8 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>Oxygen Test</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="firePrecaution8"
                                  value={formData.firePrecaution8 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>Radiography</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="certificate8"
                                  value={formData.certificate8 || ""}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      {/* Permit Applicant and Holder Section */}

                      <div className="permit-signatures">
                        <h3>Permit Applicant & Permit Holder</h3>
                        <table className="work-table">
                          <tbody>
                            {/* First Row */}
                            <tr>
                              <td>
                                {" "}
                                <label>Permit Applicant Name: </label>
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="permitappname"
                                  value={formData.permitappname || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                {" "}
                                <label>Sign: </label>
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="permitappsign"
                                  value={formData.permitappsign || ""}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>

                            {/* Second Row */}
                            <tr>
                              <td>
                                {" "}
                                <label>Permit Holder Name: </label>
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="permitholdname"
                                  value={formData.permitholdname || ""}
                                  onChange={handleChange}
                                />
                              </td>

                              <td>
                                <label>Sign: </label>
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="permitholdsign"
                                  value={formData.permitholdsign || ""}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div className="permit-signatures">
                        <h3>Permit Authoriser Permit Validity</h3>
                        <table className="work-table">
                          <tbody>
                            {/* First Row */}
                            <tr>
                              <td>
                                {" "}
                                <label>Date From: </label>
                              </td>
                              <td>
                                <input
                                  type="date"
                                  name="permitauthdatefrom"
                                  value={formData.permitauthdatefrom || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                {" "}
                                <label>Date To: </label>
                              </td>
                              <td>
                                <input
                                  type="date"
                                  name="permitauthdateto"
                                  value={formData.permitauthdateto || ""}
                                  onChange={handleChange}
                                />
                                {errors.permitauthdateto && (
                                  <span style={{ color: "red" }}>
                                    {errors.permitauthdateto}
                                  </span>
                                )}
                              </td>
                              <td>
                                {" "}
                                <label>Name: </label>
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="permitauthname"
                                  value={formData.permitauthname || ""}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>

                            {/* Second Row */}
                            <tr>
                              <td>
                                {" "}
                                <label>Time From: </label>
                              </td>
                              <td>
                                <TimePicker
                                  onChange={handlePermitTimeChange}
                                  value={formData.permitauthtimefrom}
                                  format="h:mm a"
                                  disableClock={true}
                                  clearIcon={null}
                                />
                              </td>
                              <td>
                                {" "}
                                <label>Time To: </label>
                              </td>
                              <td>
                                {" "}
                                <TimePicker
                                  onChange={handlePermitTimeToChange}
                                  value={formData.permitauthtimeto}
                                  format="h:mm a"
                                  disableClock={true}
                                  clearIcon={null}
                                />
                                {errors.permitauthtimeto && (
                                  <span style={{ color: "red" }}>
                                    {errors.permitauthtimeto}
                                  </span>
                                )}
                              </td>
                              <td>
                                {" "}
                                <label>Sign: </label>
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="permitauthsign"
                                  value={formData.permitauthsign || ""}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {/* Permit Return and Cancellation */}
                      <div className="permit-return-section">
                        <h3>4A Permit Return - Work Complete</h3>
                        <table className="permit-return-table">
                          <thead>
                            <tr>
                              <th style={{ width: "30%" }}>Description</th>
                              <th>Name</th>
                              <th>Sign</th>
                              <th>Date</th>
                              <th>Time</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                Permit Return by Permit Holder, Work Complete.
                                Work Site & Equipment affected Left in Safe
                                Condition
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="permitwcholdersign"
                                  value={formData.permitwcholdersign || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="permitwcholdername"
                                  value={formData.permitwcholdername || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <input
                                  type="date"
                                  name="permitwcholderdate"
                                  value={formData.permitwcholderdate || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <TimePicker
                                  onChange={handlePermitwcholdertimeChange}
                                  value={formData.permitwcholdertime}
                                  format="h:mm a"
                                  disableClock={true}
                                  clearIcon={null}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>Permit return by Applicant</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="permitwcapplicantsign"
                                  value={formData.permitwcapplicantsign || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="permitwcapplicantname"
                                  value={formData.permitwcapplicantname || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <input
                                  type="date"
                                  name="permitwcapplicantdate"
                                  value={formData.permitwcapplicantdate || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <TimePicker
                                  onChange={handlePermitwcapplicanttimeChange}
                                  value={formData.permitwcapplicanttime}
                                  format="h:mm a"
                                  disableClock={true}
                                  clearIcon={null}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>Permit Accepted by Authoriser</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="permitwcAuthorisersign"
                                  value={formData.permitwcAuthorisersign || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="permitwcAuthorisername"
                                  value={formData.permitwcAuthorisername || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <input
                                  type="date"
                                  name="permitwcAuthoriserdate"
                                  value={formData.permitwcAuthoriserdate || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <TimePicker
                                  onChange={handlePermitwcAuthorisertimeChange}
                                  value={formData.permitwcAuthorisertime}
                                  format="h:mm a"
                                  disableClock={true}
                                  clearIcon={null}
                                />
                              </td>
                            </tr>
                            {/* Add more rows */}
                          </tbody>
                        </table>
                      </div>
                      {/* Permit Return and Cancellation */}
                      <div className="permit-return-section">
                        <h3>4B Permit Return - Work Not Complete</h3>
                        <table className="permit-return-table">
                          <thead>
                            <tr>
                              <th style={{ width: "30%" }}>Description</th>
                              <th>Name</th>
                              <th>Sign</th>
                              <th>Date</th>
                              <th>Time</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                Permit Return by Permit Holder, Work Not
                                Complete(WNC). Work Site & Equipment affected
                                Left in Safe Condition
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="permitwncholdersign"
                                  value={formData.permitwncholdersign || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="permitwncholdername"
                                  value={formData.permitwncholdername || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <input
                                  type="date"
                                  name="permitwncholderdate"
                                  value={formData.permitwncholderdate || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <TimePicker
                                  onChange={handlePermitwncholdertimeChange}
                                  value={formData.permitwncholdertime}
                                  format="h:mm a"
                                  disableClock={true}
                                  clearIcon={null}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>Permit return by Applicant</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="permitwncapplicantsign"
                                  value={formData.permitwncapplicantsign || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="permitwncapplicantname"
                                  value={formData.permitwncapplicantname || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <input
                                  type="date"
                                  name="permitwncapplicantdate"
                                  value={formData.permitwncapplicantdate || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <TimePicker
                                  onChange={handlePermitwncapplicanttimeChange}
                                  value={formData.permitwncapplicanttime}
                                  format="h:mm a"
                                  disableClock={true}
                                  clearIcon={null}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>Permit Accepted by Authoriser</td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="permitwncAuthorisersign"
                                  value={formData.permitwncAuthorisersign || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <PopupInputField
                                  type="text"
                                  name="permitwncAuthorisername"
                                  value={formData.permitwncAuthorisername || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <input
                                  type="date"
                                  name="permitwncAuthoriserdate"
                                  value={formData.permitwncAuthoriserdate || ""}
                                  onChange={handleChange}
                                />
                              </td>
                              <td>
                                <TimePicker
                                  onChange={handlePermitwncAuthorisertimeChange}
                                  value={formData.permitwncAuthorisertime}
                                  format="h:mm a"
                                  disableClock={true}
                                  clearIcon={null}
                                />
                              </td>
                            </tr>
                            {/* Add more rows */}
                          </tbody>
                        </table>
                      </div>
                      {nextUser && (
                        <div className="department-certificate-form__group">
                          <h3>Select Departments</h3>
                          <table className="department-certificate-form__table">
                            <tbody>
                              {divisionData.map((option, index) => (
                                <tr key={index}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      className="employee-selection-modal-checkbox"
                                      value={option.value}
                                      checked={
                                        selectedDepartments[option.value] ||
                                        false
                                      }
                                      onChange={handleDepartmentChange}
                                    />
                                  </td>
                                  <td
                                    colSpan={option.colSpan || 1}
                                    style={{ fontWeight: "bold" }}
                                  >
                                    {option.label}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          {errors.selectedDepartments && (
                            <p style={{ color: "red", fontSize: "12px" }}>
                              {errors.selectedDepartments}
                            </p>
                          )}
                        </div>
                      )}

                      {availableDivision && (
                        <div className="department-certificate-form__group">
                          <h3>Select Departments</h3>
                          <table className="department-certificate-form__table">
                            <tbody>
                              {divisionData.map((option, index) => (
                                <tr key={index}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      className="employee-selection-modal-checkbox"
                                      value={option.value}
                                      checked={
                                        selectedDepartments[option.value] ||
                                        false
                                      }
                                      onChange={handleDepartmentChange}
                                      disabled
                                    />
                                  </td>
                                  <td
                                    colSpan={option.colSpan || 1}
                                    style={{ fontWeight: "bold" }}
                                  >
                                    {option.label}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>
                </Tab>
              )}

              {visibleTabs.includes("electrical") && (
                <Tab eventKey="electrical" title="Electrical-HCC">
                  <div ref={formRefs.electrical}>
                    <div className="electrical-certificate-form">
                      <div className="logo-container">
                        <img
                          src={orgImg}
                          alt="Organization Logo"
                          style={{
                            width: "130px",
                            height: "50px",
                            backgroundColor: "transparent",
                            borderRadius: "2px",
                          }}
                        />
                      </div>
                      <h2 className="center-heading">ELECTRICAL CERTIFICATE</h2>
                      <p className="electrical-certificate-form__subtitle">
                        THIS IS NOT A PERMIT TO WORK
                      </p>
                      <div className="electrical-certificate-form__section">
                        <h2 className="electrical-certificate-form__heading">
                          Hot work / Cold Work permit - Permit no:
                          <input
                            type="text"
                            className="electrical-certificate-form__input"
                            placeholder="Permit no"
                            name="permitNo"
                            value={electricalFormData.permitNo || ""}
                            onChange={handleElectricalFormChange}
                            readOnly
                          />
                          Certificate No:
                          <PopupInputField
                            type="text"
                            className="electrical-certificate-form__input"
                            placeholder="Certificate no"
                            name="certificateno"
                            value={electricalFormData.certificateno || ""}
                            onChange={handleElectricalFormChange}
                          />
                        </h2>

                        <div className="electrical-certificate-form__group">
                          <label className="electrical-certificate-form__label">
                            A) Plant/Area:
                          </label>
                          <table className="electrical-certificate-form__table">
                            <tbody>
                              <tr>
                                <td style={{ width: "20%" }}>
                                  <label>Plant/Area</label>
                                </td>

                                <td>
                                  <PopupInputField
                                    type="text"
                                    className="electrical-certificate-form__input"
                                    placeholder="Enter Area or Plant"
                                    name="plantArea" // Unique name for this field
                                    value={electricalFormData.plantArea || ""} // Controlled value
                                    onChange={handleElectricalFormChange} // Change handler
                                  />
                                </td>
                                <td style={{ width: "20%" }}>
                                  {" "}
                                  <label>Equipment Tag No</label>
                                </td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    className="electrical-certificate-form__input"
                                    placeholder="Enter Equipment Tag No"
                                    name="equipmentTagNo"
                                    value={
                                      electricalFormData.equipmentTagNo || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  {" "}
                                  <label>Name of the contractor</label>
                                </td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    className="electrical-certificate-form__input"
                                    placeholder="No. of contractor"
                                    name="contractorName"
                                    value={
                                      electricalFormData.contractorName || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                  />
                                </td>
                                <td>
                                  {" "}
                                  <label>No. of Workers</label>
                                </td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    className="electrical-certificate-form__input"
                                    placeholder="No. of Workers"
                                    name="numberOfWorkers"
                                    value={
                                      electricalFormData.numberOfWorkers || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  {" "}
                                  <label>Location of the job</label>
                                </td>

                                <td colSpan="4">
                                  <textarea
                                    rows="3"
                                    name="jobLocation"
                                    style={{ width: "100%" }}
                                    placeholder="Details of the job"
                                    value={electricalFormData.jobLocation || ""}
                                    onChange={handleElectricalFormChange}
                                  ></textarea>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div className="electrical-certificate-form__group">
                          <label className="electrical-certificate-form__label">
                            B) Clearance by Operations
                          </label>
                          <p className="electrical-certificate-form__text">
                            Clearance from operations dept. is hereby granted
                            for carrying out the above job.
                          </p>
                          <table className="electrical-certificate-form__table">
                            <tbody>
                              <tr>
                                <td>
                                  <label>Name</label>
                                </td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    className="electrical-certificate-form__input"
                                    placeholder="Enter name"
                                    name="name"
                                    value={electricalFormData.name || ""}
                                    onChange={handleElectricalFormChange}
                                  />
                                </td>
                                <td>
                                  <label>Signature</label>
                                </td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    className="electrical-certificate-form__input"
                                    placeholder="Enter signature"
                                    name="signature"
                                    value={electricalFormData.signature || ""}
                                    onChange={handleElectricalFormChange}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <label>Date</label>
                                </td>
                                <td>
                                  <input
                                    type="date"
                                    className="electrical-certificate-form__input"
                                    name="date"
                                    value={electricalFormData.date || ""}
                                    onChange={handleElectricalFormChange}
                                  />
                                </td>
                                <td>
                                  <label>Time</label>
                                </td>
                                <td>
                                  <TimePicker
                                    onChange={handleEletricTimeChange}
                                    value={electricalFormData.time}
                                    format="h:mm a"
                                    disableClock={true}
                                    clearIcon={null}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div className="electrical-certificate-form__group">
                          <label className="electrical-certificate-form__label">
                            C) Precautions taken (Tick mark which are
                            applicable, strike out whichever not applicable)
                          </label>
                          <table className="electrical-certificate-form__table">
                            <tbody>
                              <tr>
                                <td>
                                  <input
                                    type="checkbox"
                                    name="normalSupply"
                                    checked={
                                      electricalFormData.normalSupply || false
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__checkbox"
                                  />
                                </td>
                                <td>Normal supply</td>
                                <td>
                                  <input
                                    type="checkbox"
                                    name="alternativeSupply"
                                    checked={
                                      electricalFormData.alternativeSupply ||
                                      false
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__checkbox"
                                  />
                                </td>
                                <td>Alternative supply</td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="checkbox"
                                    name="switchesOut"
                                    checked={
                                      electricalFormData.switchesOut || false
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__checkbox"
                                  />
                                </td>
                                <td>Switches out / Off</td>
                                <td>
                                  <input
                                    type="checkbox"
                                    name="powerFuseRemoved"
                                    checked={
                                      electricalFormData.powerFuseRemoved ||
                                      false
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__checkbox"
                                  />
                                </td>
                                <td>Power fuse removed</td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="checkbox"
                                    name="controlFusesRemoved"
                                    checked={
                                      electricalFormData.controlFusesRemoved ||
                                      false
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__checkbox"
                                  />
                                </td>
                                <td>Control/space heater fuses removed</td>
                                <td>
                                  <input
                                    type="checkbox"
                                    name="breakerRackedOut"
                                    checked={
                                      electricalFormData.breakerRackedOut ||
                                      false
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__checkbox"
                                  />
                                </td>
                                <td>Breaker racked out</td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="checkbox"
                                    name="tagsProvided"
                                    checked={
                                      electricalFormData.tagsProvided || false
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__checkbox"
                                  />
                                </td>
                                <td>Do Not Operate tags provided, Tag No.</td>
                                <td>
                                  <input
                                    type="checkbox"
                                    name="terminalEarthed"
                                    checked={
                                      electricalFormData.terminalEarthed ||
                                      false
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__checkbox"
                                  />
                                </td>
                                <td>
                                  Terminal / Cable earthed and short circuited
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="checkbox"
                                    name="earthContinuityChecked"
                                    checked={
                                      electricalFormData.earthContinuityChecked ||
                                      false
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__checkbox"
                                  />
                                </td>
                                <td>Earth continuity checked</td>
                                <td>
                                  <input
                                    type="checkbox"
                                    name="useElectricalGloves"
                                    checked={
                                      electricalFormData.useElectricalGloves ||
                                      false
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__checkbox"
                                  />
                                </td>
                                <td>Use electrical gloves rated 11/33 KV</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div className="electrical-certificate-form__group">
                          <label className="electrical-certificate-form__label">
                            D) Special Instructions:
                          </label>
                          <textarea
                            rows="4"
                            cols="50"
                            name="splInstructions"
                            value={electricalFormData.splInstructions || ""}
                            onChange={handleElectricalFormChange}
                            className="electrical-certificate-form__textarea"
                          ></textarea>
                        </div>
                        <div className="electrical-certificate-form__group">
                          <label className="electrical-certificate-form__label">
                            E) Applicant & Authorizer : Certify that the
                            precautions are fulfilled and work site plus
                            equipment are ready and safe for the job
                          </label>
                          <table className="electrical-certificate-form__signature-table">
                            <thead>
                              <tr>
                                <th>Designation</th>
                                <th>Name</th>
                                <th>Signature</th>
                                <th>Date</th>
                                <th>Time</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Applicant</td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="applicantName"
                                    className="electrical-certificate-form__input"
                                    value={electricalFormData.applicantName}
                                    onChange={handleElectricalFormChange}
                                  />
                                </td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="fieldTwo"
                                    className="electrical-certificate-form__input"
                                    value={electricalFormData.fieldTwo}
                                    onChange={handleElectricalFormChange}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="date"
                                    name="applicantdate"
                                    className="electrical-certificate-form__input"
                                    value={electricalFormData.applicantdate}
                                    onChange={handleElectricalFormChange}
                                  />
                                </td>
                                <td>
                                  <TimePicker
                                    onChange={handleEletricApplicantTimeChange}
                                    value={electricalFormData.applicanttime}
                                    format="h:mm a"
                                    disableClock={true}
                                    clearIcon={null}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>Authoriser</td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="authoriserName"
                                    className="electrical-certificate-form__input"
                                    value={electricalFormData.authoriserName}
                                    onChange={handleElectricalFormChange}
                                  />
                                </td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="authoriserfieldTwo"
                                    className="electrical-certificate-form__input"
                                    value={
                                      electricalFormData.authoriserfieldTwo
                                    }
                                    onChange={handleElectricalFormChange}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="date"
                                    name="authoriserDate"
                                    className="electrical-certificate-form__input"
                                    value={electricalFormData.authoriserDate}
                                    onChange={handleElectricalFormChange}
                                  />
                                </td>
                                <td>
                                  <TimePicker
                                    onChange={handleEletricAuthTimeChange}
                                    value={electricalFormData.authoriserTime}
                                    format="h:mm a"
                                    disableClock={true}
                                    clearIcon={null}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>Holder</td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="holderName"
                                    className="electrical-certificate-form__input"
                                    value={electricalFormData.holderName}
                                    onChange={handleElectricalFormChange}
                                  />
                                </td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="holderSign"
                                    className="electrical-certificate-form__input"
                                    value={electricalFormData.holderSign}
                                    onChange={handleElectricalFormChange}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="date"
                                    name="holderDate"
                                    className="electrical-certificate-form__input"
                                    value={electricalFormData.holderDate}
                                    onChange={handleElectricalFormChange}
                                  />
                                </td>
                                <td>
                                  <TimePicker
                                    onChange={handleEletricHolderTimeChange}
                                    value={electricalFormData.holderTime}
                                    format="h:mm a"
                                    disableClock={true}
                                    clearIcon={null}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div className="electrical-certificate-form__group">
                          <label className="electrical-certificate-form__label">
                            F) Extension of Validity (to be renewed every shift
                            - max. validity - 24 Hrs.)
                          </label>
                          <p className="electrical-certificate-form__text">
                            Conditions checked and the permit is re-validated as
                            under:
                          </p>
                          <table className="electrical-certificate-form__signature-table">
                            <thead>
                              <tr>
                                <th colSpan="2">Applicant</th>
                                <th colSpan="2">Authorizer</th>
                                <th style={{ width: "35%" }} colSpan="2">
                                  Extended Up To
                                </th>
                              </tr>
                              <tr>
                                <th>Name</th>
                                <th>Signature</th>
                                <th>Name</th>
                                <th>Signature</th>
                                <th>Date</th>
                                <th>Time</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="extapplicantname"
                                    value={
                                      electricalFormData.extapplicantname || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="extapplicantsign"
                                    value={
                                      electricalFormData.extapplicantsign || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="extauthorisedname"
                                    value={
                                      electricalFormData.extauthorisedname || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="extauthorisedsign"
                                    value={
                                      electricalFormData.extauthorisedsign || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="date"
                                    name="extextenddate"
                                    value={
                                      electricalFormData.extextenddate || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  <TimePicker
                                    onChange={handleEletricExtendTimeChange}
                                    value={electricalFormData.extextendtime}
                                    format="h:mm a"
                                    disableClock={true}
                                    clearIcon={null}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="extapplicantname1"
                                    value={
                                      electricalFormData.extapplicantname1 || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="extapplicantsign1"
                                    value={
                                      electricalFormData.extapplicantsign1 || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="extauthorisedname1"
                                    value={
                                      electricalFormData.extauthorisedname1 ||
                                      ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="extauthorisedsign1"
                                    value={
                                      electricalFormData.extauthorisedsign1 ||
                                      ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="date"
                                    name="extextenddate1"
                                    value={
                                      electricalFormData.extextenddate1 || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  {" "}
                                  <TimePicker
                                    onChange={handleEletricExtend1TimeChange}
                                    value={electricalFormData.extextendtime1}
                                    format="h:mm a"
                                    disableClock={true}
                                    clearIcon={null}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="extapplicantname2"
                                    value={
                                      electricalFormData.extapplicantname2 || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="extapplicantsign2"
                                    value={
                                      electricalFormData.extapplicantsign2 || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="extauthorisedname2"
                                    value={
                                      electricalFormData.extauthorisedname2 ||
                                      ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="extauthorisedsign2"
                                    value={
                                      electricalFormData.extauthorisedsign2 ||
                                      ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="date"
                                    name="extextenddate2"
                                    value={
                                      electricalFormData.extextenddate2 || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  {" "}
                                  <TimePicker
                                    onChange={handleEletricExtend2TimeChange}
                                    value={electricalFormData.extextendtime2}
                                    format="h:mm a"
                                    disableClock={true}
                                    clearIcon={null}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div className="electrical-certificate-form__group">
                          <label className="electrical-certificate-form__label">
                            G) Job completion and closure of certificate:
                          </label>
                          <p className="electrical-certificate-form__text">
                            Job is completed and we have inspected the site &
                            found the area cleared of men and materials.
                            Temporary earths also removed.
                          </p>
                          <label className="electrical-certificate-form__label">
                            Certificate is hereby closed.
                          </label>
                          <table className="electrical-certificate-form__signature-table">
                            <thead>
                              <tr>
                                <th></th>
                                <th>Name</th>
                                <th>Signature</th>
                                <th>Date</th>
                                <th>Time</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Authoriser</td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="jobAuthrosiername"
                                    value={
                                      electricalFormData.jobAuthrosiername || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="jobAuthrosiersign"
                                    value={
                                      electricalFormData.jobAuthrosiersign || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="date"
                                    name="jobAuthrosierdate"
                                    value={
                                      electricalFormData.jobAuthrosierdate || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  {" "}
                                  <TimePicker
                                    onChange={handleEletricJobAuthTimeChange}
                                    value={electricalFormData.jobAuthrosiertime}
                                    format="h:mm a"
                                    disableClock={true}
                                    clearIcon={null}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>Applicant</td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="jobApplicantname"
                                    value={
                                      electricalFormData.jobApplicantname || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="jobApplicantsign"
                                    value={
                                      electricalFormData.jobApplicantsign || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="date"
                                    name="jobApplicantdate"
                                    value={
                                      electricalFormData.jobApplicantdate || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  {" "}
                                  <TimePicker
                                    onChange={
                                      handleEletricJobApplicantTimeChange
                                    }
                                    value={electricalFormData.jobApplicanttime}
                                    format="h:mm a"
                                    disableClock={true}
                                    clearIcon={null}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>Holder</td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="jobholdername"
                                    value={
                                      electricalFormData.jobholdername || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  <PopupInputField
                                    type="text"
                                    name="jobholdersign"
                                    value={
                                      electricalFormData.jobholdersign || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="date"
                                    name="jobholderdate"
                                    value={
                                      electricalFormData.jobholderdate || ""
                                    }
                                    onChange={handleElectricalFormChange}
                                    className="electrical-certificate-form__input"
                                  />
                                </td>
                                <td>
                                  {" "}
                                  <TimePicker
                                    onChange={handleEletricJobHolderTimeChange}
                                    value={electricalFormData.jobholdertime}
                                    format="h:mm a"
                                    disableClock={true}
                                    clearIcon={null}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab>
              )}

              {visibleTabs.includes("saftey") && (
                <Tab eventKey="saftey" title="Saftey-HCC">
                  <div ref={formRefs.saftey}>
                    <div className="heavylift-form-container">
                      <div className="logo-container">
                        <img
                          src={orgImg}
                          alt="Organization Logo"
                          style={{
                            width: "130px",
                            height: "50px",
                            backgroundColor: "transparent",
                            borderRadius: "2px",
                          }}
                        />
                      </div>
                      <h2 className="center-heading">HEAVY LIFT CERTIFICATE</h2>
                      <table className="heavylift-form-table">
                        <tbody>
                          <tr>
                            <td className="heavylift-form-label">Permit No:</td>
                            <td>
                              <input
                                type="text"
                                name="permitNo"
                                value={heavyLiftFormData.permitNo}
                                readOnly
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              Certificate No:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="certificateNo"
                                value={heavyLiftFormData.certificateNo}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">Location:</td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="location"
                                value={heavyLiftFormData.location}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">Date:</td>
                            <td>
                              <input
                                type="date"
                                name="date"
                                value={heavyLiftFormData.date}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">Time:</td>
                            <td>
                              {" "}
                              <TimePicker
                                onChange={handleSafteyTimeChange}
                                value={heavyLiftFormData.time}
                                format="h:mm a"
                                disableClock={true}
                                clearIcon={null}
                              />
                            </td>
                          </tr>

                          <tr>
                            <td colSpan="2" className="heavylift-section-title">
                              Lift Information
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              Description of Load:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="descriptionOfLoad"
                                value={heavyLiftFormData.descriptionOfLoad}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              Weight of load:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="weightOfLoad"
                                value={heavyLiftFormData.weightOfLoad}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              Dimensions:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="dimensions"
                                value={heavyLiftFormData.dimensions}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="2" className="heavylift-section-title">
                              Equipment & Load Information
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">Crane:</td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="crane"
                                value={heavyLiftFormData.crane}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">Type:</td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="type"
                                value={heavyLiftFormData.type}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">Model:</td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="model"
                                value={heavyLiftFormData.model}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              Competent Person Test Certificate Validity:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="person"
                                value={heavyLiftFormData.person}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="2" className="heavylift-section-title">
                              Crane Information
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              A. Maximum Operating Radius:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="maxOperatingRadius"
                                value={heavyLiftFormData.maxOperatingRadius}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              B. Main boom length:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="mainBoomLength"
                                value={heavyLiftFormData.mainBoomLength}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              C. Jib length:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="jibLength"
                                value={heavyLiftFormData.jibLength}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              D. Jib Offset:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="jibOffset"
                                value={heavyLiftFormData.jibOffset}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              E. Attachments (Luffing jib, Super lift):
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="attachments"
                                value={heavyLiftFormData.attachments}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              F. Counterweights required:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="counterweights"
                                value={heavyLiftFormData.counterweights}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              G. Vertical Clearance between boom Hook & load:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="verticalClearance"
                                value={heavyLiftFormData.verticalClearance}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="2" className="heavylift-section-title">
                              Competency of Crane Operator (Mention the Details)
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              Driving License:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="drivingLicense"
                                value={heavyLiftFormData.drivingLicense}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              Medical Fitness:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="medicalFitness"
                                value={heavyLiftFormData.medicalFitness}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              Certified (OEM) Training:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="certifiedTraining"
                                value={heavyLiftFormData.certifiedTraining}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              Crane operator name
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="craneOperatorName"
                                value={heavyLiftFormData.craneOperatorName}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              Crane operator Sign:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="craneOperatorSign"
                                value={heavyLiftFormData.craneOperatorSign}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td colSpan="2" className="heavylift-section-title">
                              Site Conditions
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              H. Obstructions:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="obstructions"
                                value={heavyLiftFormData.obstructions}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              I. Distance from power lines:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="distanceFromPowerLines"
                                value={heavyLiftFormData.distanceFromPowerLines}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              J. Ground Stability:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="groundStability"
                                value={heavyLiftFormData.groundStability}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              K. Underground utilities:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="undergroundUtilities"
                                value={heavyLiftFormData.undergroundUtilities}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              L. Wooden Stoppers or mats needed?
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="woodenStoppers"
                                value={heavyLiftFormData.woodenStoppers}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="2" className="heavylift-section-title">
                              Calculations
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              M. Lifting Capacity:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="liftingCapacity"
                                value={heavyLiftFormData.liftingCapacity}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              N. Weight of load:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="calweightOfLoad"
                                value={heavyLiftFormData.calweightOfLoad}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              O. Total weight of accessories:
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="totalWeightOfAccessories"
                                value={
                                  heavyLiftFormData.totalWeightOfAccessories
                                }
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              P. Total weight of lift (N + O):
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="totalWeightOfLift"
                                value={heavyLiftFormData.totalWeightOfLift}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              * Authorised Engineer Sign
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="authorisedEngineerSign"
                                value={heavyLiftFormData.authorisedEngineerSign}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="heavylift-form-label">
                              Authorised Engineer Name
                            </td>
                            <td>
                              <PopupInputField
                                type="text"
                                name="authorisedEngineerName"
                                value={heavyLiftFormData.authorisedEngineerName}
                                onChange={handleHeavyLiftFormChange}
                                className="heavylift-form-input"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <p className="heavylift-form-note">
                        * Authorised engineer must undergo Permit to Work, Lock
                        Out and Tag Out, Working at Height, Confined Space Entry
                        Trainings
                      </p>
                    </div>
                  </div>
                </Tab>
              )}

              {visibleTabs.includes("maintance") && (
                <Tab eventKey="maintance" title="Radiopraphy/Chemical-HCC">
                  <div ref={formRefs.maintance}>
                    <div className="radiography-form">
                      <div className="logo-container">
                        <img
                          src={orgImg}
                          alt="Organization Logo"
                          style={{
                            width: "130px",
                            height: "50px",
                            backgroundColor: "transparent",
                            borderRadius: "2px",
                          }}
                        />
                      </div>
                      <h2 className="center-heading">
                        Radiopraphy/Chemical-HCC
                      </h2>
                      <div className="radiography-section radiography-applicant-details">
                        <h3>1. Applied by Permit Applicant</h3>
                        <div className="radiography-authorization-box">
                          <div className="radiography-form-row">
                            <div className="radiography-input-group">
                              <label>Name</label>
                              <PopupInputField
                                type="text"
                                name="name"
                                value={radiographyFormData.name}
                                onChange={handleRadiographFormChange}
                                className="radiography-input-field"
                              />
                            </div>
                            <div className="radiography-input-group">
                              <label>Sign</label>
                              <PopupInputField
                                type="text"
                                name="sign"
                                value={radiographyFormData.sign}
                                onChange={handleRadiographFormChange}
                                className="radiography-input-field"
                              />
                            </div>

                            <div className="radiography-input-group">
                              <label>Date</label>
                              <input
                                type="date"
                                name="date"
                                value={radiographyFormData.date}
                                onChange={handleRadiographFormChange}
                                className="radiography-input-field"
                              />
                            </div>
                          </div>
                          <div className="radiography-form-row">
                            <div className="radiography-input-group">
                              <label>Plant</label>
                              <PopupInputField
                                type="text"
                                name="plant"
                                value={radiographyFormData.plant}
                                onChange={handleRadiographFormChange}
                                className="radiography-input-field"
                              />
                            </div>
                            <div className="radiography-input-group">
                              <label>Location</label>
                              <PopupInputField
                                type="text"
                                name="location"
                                value={radiographyFormData.location}
                                onChange={handleRadiographFormChange}
                                className="radiography-input-field"
                              />
                            </div>
                            <div className="radiography-input-group">
                              <label>Certificate No.</label>
                              <PopupInputField
                                type="text"
                                name="certificateNo"
                                value={radiographyFormData.certificateNo}
                                onChange={handleRadiographFormChange}
                                className="radiography-input-field"
                              />
                            </div>
                            <div className="radiography-input-group">
                              <label>Permit No.</label>
                              <input
                                type="text"
                                name="permitNo"
                                value={formData.permitNo || ""}
                                readonly
                                onChange={handleRadiographFormChange}
                                className="radiography-input-field"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="radiography-section radiography-reason">
                        <h3>2. Reason for Radiography</h3>
                        <textarea
                          name="reason"
                          value={radiographyFormData.reason}
                          onChange={handleRadiographFormChange}
                          className="radiography-textarea-field"
                        ></textarea>
                        <h4>A. General Information</h4>
                        <div className="radiography-authorization-box">
                          <div className="radiography-form-row">
                            <label>Radiation Source</label>
                            <PopupInputField
                              type="text"
                              name="radiosouce"
                              value={radiographyFormData.radiosouce}
                              onChange={handleRadiographFormChange}
                              className="radiography-input-field"
                            />
                          </div>
                          <div className="radiography-form-row">
                            <label>X-Ray Apparatus: Make</label>
                            <PopupInputField
                              type="text"
                              name="xrayMake"
                              value={radiographyFormData.xrayMake}
                              onChange={handleRadiographFormChange}
                              className="radiography-input-field"
                            />
                            <label>Type</label>
                            <PopupInputField
                              type="text"
                              name="xrayType"
                              value={radiographyFormData.xrayType}
                              onChange={handleRadiographFormChange}
                              className="radiography-input-field"
                            />
                            <label>Max. Tube Voltage</label>
                            <PopupInputField
                              type="number"
                              name="maxTubeVoltage"
                              value={radiographyFormData.maxTubeVoltage}
                              onChange={handleRadiographFormChange}
                              className="radiography-input-field"
                            />
                          </div>
                          <div className="radiography-form-row">
                            <label>Radioactive Substance</label>
                            <div className="radiography-radio-group">
                              <label>
                                <input
                                  type="radio"
                                  name="radioactiveSubstance"
                                  value="sealed"
                                  checked={
                                    radiographyFormData.radioactiveSubstance ===
                                      "sealed" || false
                                  }
                                  onChange={handleRadiographFormChange}
                                />
                                Sealed
                              </label>
                              <label>
                                <input
                                  type="radio"
                                  name="radioactiveSubstance"
                                  value="unsealed"
                                  checked={
                                    radiographyFormData.radioactiveSubstance ===
                                      "unsealed" || false
                                  }
                                  onChange={handleRadiographFormChange}
                                />
                                Unsealed
                              </label>
                            </div>
                          </div>
                          <div className="radiography-form-row">
                            <label>Total Activity</label>
                            <PopupInputField
                              type="text"
                              name="totalActivity"
                              value={radiographyFormData.totalActivity}
                              onChange={handleRadiographFormChange}
                              className="radiography-input-field"
                            />
                            <label>Half Life</label>
                            <PopupInputField
                              type="text"
                              name="halfLife"
                              value={radiographyFormData.halfLife}
                              onChange={handleRadiographFormChange}
                              className="radiography-input-field"
                            />
                            <label>Isotope</label>
                            <PopupInputField
                              type="text"
                              name="isotope"
                              value={radiographyFormData.isotope}
                              onChange={handleRadiographFormChange}
                              className="radiography-input-field"
                            />
                          </div>
                          <div className="radiography-form-row">
                            <label>Type of Radiation</label>
                            <div className="radiography-checkbox-group">
                              <label>
                                <input
                                  type="checkbox"
                                  name="alpha"
                                  checked={radiographyFormData.alpha || false}
                                  onChange={handleRadiographFormChange}
                                />
                                Alpha
                              </label>
                              <label>
                                <input
                                  type="checkbox"
                                  name="beta"
                                  checked={radiographyFormData.beta || false}
                                  onChange={handleRadiographFormChange}
                                />
                                Beta
                              </label>
                              <label>
                                <input
                                  type="checkbox"
                                  name="gamma"
                                  checked={radiographyFormData.gamma || false}
                                  onChange={handleRadiographFormChange}
                                />
                                Gamma
                              </label>
                              <label>
                                <input
                                  type="checkbox"
                                  name="neutron"
                                  checked={radiographyFormData.neutron || false}
                                  onChange={handleRadiographFormChange}
                                />
                                Neutron
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="radiography-section radiography-special-precautions">
                        <h3>B. Special Precaution to Be Taken</h3>
                        <textarea
                          name="specialPrecautions"
                          value={radiographyFormData.specialPrecautions}
                          onChange={handleRadiographFormChange}
                          className="radiography-textarea-field"
                        ></textarea>
                      </div>

                      <div className="radiography-section radiography-authorization">
                        <div className="radiography-authorization-box">
                          <h3>3. Permit Authoriser</h3>
                          <p>
                            I Authorize the radiography test specified above to
                            be carried out, subject to the nominated safety
                            precaution and conditions being maintained during
                            the validity period of the permit(s) to work
                            specified in the certificate.
                          </p>
                          <div className="radiography-form-row">
                            <label>Name</label>
                            <PopupInputField
                              type="text"
                              name="permitAuthorisername"
                              value={radiographyFormData.permitAuthorisername}
                              onChange={handleRadiographFormChange}
                              className="radiography-input-field"
                            />
                            <label>Sign</label>
                            <PopupInputField
                              type="text"
                              name="permitAuthorisersign"
                              value={radiographyFormData.permitAuthorisersign}
                              onChange={handleRadiographFormChange}
                              className="radiography-input-field"
                            />

                            <label>Date</label>
                            <input
                              type="date"
                              name="permitAuthoriserdate"
                              value={radiographyFormData.permitAuthoriserdate}
                              onChange={handleRadiographFormChange}
                              className="radiography-input-field"
                            />
                            <label>Time</label>

                            <TimePicker
                              onChange={handleRadioTimeChange}
                              value={radiographyFormData.permitAuthorisertime}
                              format="h:mm a"
                              disableClock={true}
                              clearIcon={null}
                            />
                          </div>
                        </div>
                        <div className="radiography-authorization-box">
                          <h3>
                            4. Permit Holder (Qualified Radiation Protection
                            Supervisor)
                          </h3>
                          <p>
                            I understand all the above safety precautions; I
                            will ensure that work only takes place when all
                            these safety precautions are complied with.
                          </p>
                          <div className="radiography-form-row">
                            <label>Name</label>
                            <PopupInputField
                              type="text"
                              name="permitHoldername"
                              value={radiographyFormData.permitHoldername}
                              onChange={handleRadiographFormChange}
                              className="radiography-input-field"
                            />
                            <label>Sign</label>
                            <PopupInputField
                              type="text"
                              name="permitHoldersign"
                              value={radiographyFormData.permitHoldersign}
                              onChange={handleRadiographFormChange}
                              className="radiography-input-field"
                            />

                            <label>Date</label>
                            <input
                              type="date"
                              name="permitHolderdate"
                              value={radiographyFormData.permitHolderdate}
                              onChange={handleRadiographFormChange}
                              className="radiography-input-field"
                            />
                            <label>Time</label>
                            <TimePicker
                              onChange={handleRadioPermitHolderTimeChange}
                              value={radiographyFormData.permitHoldertime}
                              format="h:mm a"
                              disableClock={true}
                              clearIcon={null}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab>
              )}

              {visibleTabs.includes("ele-reject") && (
                <Tab eventKey="ele-reject" title="Eletrical-Reject">
                  <div ref={formRefs.reject}>
                    <div className="reject-tab-content">
                      <textarea
                        id="elerejectReason"
                        name="elerejectReason"
                        className={`reject-textarea ${errors.elerejectReason ? "error-border" : ""}`}
                        placeholder="Type your reason here..."
                        value={elerejectFormData.elerejectReason || ""}
                        onChange={handleEleRejectReasonChange}
                        maxLength={250}
                      >
                        {errors.elerejectReason && (
                          <span className="error-text">
                            {errors.elerejectReason}
                          </span>
                        )}
                      </textarea>
                    </div>
                  </div>
                </Tab>
              )}

              {visibleTabs.includes("safety-reject") && (
                <Tab eventKey="safety-reject" title="Saftey-Reject">
                  <div ref={formRefs.reject}>
                    <div className="reject-tab-content">
                      <textarea
                        id="safetyrejectReason"
                        name="safteyrejectReason"
                        className={`reject-textarea ${errors.safteyrejectReason ? "error-border" : ""}`}
                        placeholder="Type your reason here..."
                        value={safteyrejectFormData.safteyrejectReason || ""}
                        onChange={handleSafteyRejectReasonChange}
                        maxLength={250}
                      >
                        {errors.safteyrejectReason && (
                          <span className="error-text">
                            {errors.safteyrejectReason}
                          </span>
                        )}
                      </textarea>
                    </div>
                  </div>
                </Tab>
              )}

              {visibleTabs.includes("radio-reject") && (
                <Tab eventKey="radio-reject" title="Radio-Reject">
                  <div ref={formRefs.reject}>
                    <div className="reject-tab-content">
                      <textarea
                        id="radiorejectReason"
                        name="radiorejectReason"
                        className={`reject-textarea ${errors.radiorejectReason ? "error-border" : ""}`}
                        placeholder="Type your reason here..."
                        value={radiorejectFormData.radiorejectReason || ""}
                        onChange={handleRadioRejectReasonChange}
                        maxLength={250}
                      >
                        {errors.radiorejectReason && (
                          <span className="error-text">
                            {errors.radiorejectReason}
                          </span>
                        )}
                      </textarea>
                    </div>
                  </div>
                </Tab>
              )}

              {visibleTabs.includes("ptw-reject") && (
                <Tab eventKey="ptw-reject" title="PTW-Reject">
                  <div ref={formRefs.reject}>
                    <div className="reject-tab-content">
                      <textarea
                        id="rejectReason"
                        name="rejectReason"
                        className={`reject-textarea ${errors.rejectReason ? "error-border" : ""}`}
                        placeholder="Type your reason here..."
                        value={rejectFormData.rejectReason || ""}
                        onChange={handleRejectReasonChange}
                        maxLength={250}
                      >
                        {errors.rejectReason && (
                          <span className="error-text">
                            {errors.rejectReason}
                          </span>
                        )}
                      </textarea>
                    </div>
                  </div>
                </Tab>
              )}

              {visibleTabs.includes("close") && (
                <Tab eventKey="close" title="Close">
                  <div ref={formRefs.close}>
                    <div className="reject-tab-content">
                      <textarea
                        id="rejectReason"
                        name="closeReason"
                        className={`reject-textarea ${errors.closeReason ? "error-border" : ""}`}
                        placeholder="Type your reason here..."
                        value={closeFormData.closeReason || ""}
                        onChange={handleCloseReasonChange}
                        maxLength={250}
                      >
                        {errors.closeReason && (
                          <span className="error-text">
                            {errors.closeReason}
                          </span>
                        )}
                      </textarea>
                    </div>
                  </div>
                </Tab>
              )}
              {visibleTabs.includes("publish") && (
                <Tab eventKey="publish" title="Publish">
                  <div ref={formRefs.publish}>
                    <div className="reject-tab-content">
                      <label htmlFor="rejectReason" className="reject-label">
                        Enter Descrption
                      </label>
                      <textarea
                        id="publishReason"
                        name="publishReason"
                        className="reject-textarea"
                        placeholder="Type Descrption here..."
                        value={publishFormData.publishReason || ""}
                        onChange={handlepublishReasonChange}
                        maxLength={250}
                      ></textarea>
                    </div>
                  </div>
                </Tab>
              )}

              {visibleTabs.includes("hod-reject") && (
                <Tab eventKey="hod-reject" title="HOD-Reject">
                  <div ref={formRefs.reject}>
                    <div className="reject-tab-content">
                      <textarea
                        id="rejectReason"
                        name="rejectReason"
                        className={`reject-textarea ${errors.hodrejectReason ? "error-border" : ""}`}
                        placeholder="Type your reason here..."
                        value={hodrejectFormData.hodrejectReason || ""}
                        onChange={handleHodRejectReasonChange}
                        maxLength={250}
                      >
                        {errors.hodrejectReason && (
                          <span className="error-text">
                            {errors.hodrejectReason}
                          </span>
                        )}
                      </textarea>
                    </div>
                  </div>
                </Tab>
              )}
              {visibleTabs.includes("hodVarification") && (
                <Tab eventKey="hodVarification" title="Production-HOD">
                  <div ref={formRefs.hodVarification}>
                    <div className="reject-tab-content">
                      <label htmlFor="rejectReason" className="reject-label">
                        Enter Descrption
                      </label>
                      <textarea
                        id="hodVarificationReason"
                        name="hodVarificationReason"
                        className="reject-textarea"
                        placeholder="Type Descrption here..."
                        value={
                          hodVarificationReasonFormData.hodVarificationReason ||
                          ""
                        }
                        onChange={handlehodVarificationReasonChange}
                        maxLength={250}
                      ></textarea>
                    </div>
                  </div>
                </Tab>
              )}
            </Tabs>
          </div>
        </div>

        {/* Footer */}
        <div className="popupmodal-footer">
          <div className="permit-return-section">
            <h3>Privious Comments</h3>
            <textarea
              rows="4"
              cols="50"
              name="priviousWorkComments"
              value={formData.priviousWorkComments || ""}
              onChange={handleChange}
              disabled
              style={{ cursor: "not-allowed" }}
              className="electrical-certificate-form__textarea"
            ></textarea>
          </div>

          <div className="permit-return-section">
            <h3>New Comments</h3>
            <textarea
              rows="4"
              cols="50"
              name="workComments"
              value={formData.workComments || ""}
              onChange={handleChange}
              className={`electrical-certificate-form__textarea ${errors.workComments ? "error-border" : ""}`}
            ></textarea>
            {errors.workComments && (
              <span className="error-text">{errors.workComments}</span>
            )}
          </div>

          {mode === "O" && (
            <div className="permit-return-section">
              <h3>Select Status (Next Action)</h3>
              <Select
                options={statusOptions}
                placeholder="Select Status"
                isClearable
                value={selectedOption}
                onChange={handleStatusChange}
                onMenuOpen={() => setIsMenuOpen(true)}
                onMenuClose={() => setIsMenuOpen(false)}
              />
            </div>
          )}

          <div
            className={`button-section ${isMenuOpen ? "dropdown-open" : ""}`}
          >
            <button className="print-btn" onClick={addHandleShow}>
              Open TimeLine
            </button>
            <button
              className="submit-btn"
              onClick={handleSubmit}
              disabled={!selectedOption || loading}
            >
              Update
            </button>
            <ReactToPrint
              trigger={() => <button className="print-btn">Print</button>}
              content={() => formRefs[activeTab]?.current}
            />
            <button className="print-btn" onClick={handleViewDocuments}>
              Documents
            </button>
          </div>
        </div>

        <PrintComponent
          ref={printTriggerRef}
          workId={workId}
          formRefs={formRefs}
          activeTab={activeTab}
          onFileUpload={handleFilesUpdate}
        />


        {loading && <CustomLoader />}

        {isSidebarOpen && (
          <Sidebar
            isOpen={isSidebarOpen}
            onClose={handleCloseSidebar}
            workDocs={workDocs}
            onFilesUpdate={handleFilesUpdate}
            uploadedFilePaths={filePaths}
            onTempFilesDelete={handleDeleteTemporyFiles}
            onPermentFilesDelete={handleDeletePermentFiles}
            permitNo={formData.permitNo}
            loading={loading}
            setLoading={setLoading}
          />
        )}
        <EmployeeSelectionModal
          showModal={showModal}
          employees={employees}
          selectedEmployees={selectedEmployees}
          handleEmployeeSelection={handleEmployeeSelection}
          closeModal={() => setShowModal(false)}
        />
        <MasterDialog
          open={addShow}
          onHide={addHandleClose}
          title="Timeline"
          maxWidth="md"
        >
          <Box
            sx={{
              px: 1.5,
              py: 1.5,
              maxHeight: "65vh",
              overflowY: "auto",
            }}
          >
            <WorkItemTimeLine workListHistData={workListHistData} />
          </Box>
        </MasterDialog>
      </div>
    </>
  );
};

export default WorkItemOpen;
